/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthCallbackRouteImport } from './routes/auth-callback'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedStoresTransfersRouteImport } from './routes/_authenticated/stores-transfers'
import { Route as AuthenticatedSiloCountsRouteImport } from './routes/_authenticated/silo-counts'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedSearchRouteImport } from './routes/_authenticated/search'
import { Route as AuthenticatedSalesInvoicingRouteImport } from './routes/_authenticated/sales-invoicing'
import { Route as AuthenticatedReportsRouteImport } from './routes/_authenticated/reports'
import { Route as AuthenticatedPurchasingIntakeRouteImport } from './routes/_authenticated/purchasing-intake'
import { Route as AuthenticatedProductionPackconvRouteImport } from './routes/_authenticated/production-packconv'
import { Route as AuthenticatedHelpRouteImport } from './routes/_authenticated/help'
import { Route as AuthenticatedStoresTransfersIndexRouteImport } from './routes/_authenticated/stores-transfers/index'
import { Route as AuthenticatedSiloCountsIndexRouteImport } from './routes/_authenticated/silo-counts/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSalesInvoicingIndexRouteImport } from './routes/_authenticated/sales-invoicing/index'
import { Route as AuthenticatedReportsIndexRouteImport } from './routes/_authenticated/reports/index'
import { Route as AuthenticatedPurchasingIntakeIndexRouteImport } from './routes/_authenticated/purchasing-intake/index'
import { Route as AuthenticatedProductsIndexRouteImport } from './routes/_authenticated/products/index'
import { Route as AuthenticatedProductionPackconvIndexRouteImport } from './routes/_authenticated/production-packconv/index'
import { Route as AuthenticatedSiloCountsStatusRouteImport } from './routes/_authenticated/silo-counts/status'
import { Route as AuthenticatedSiloCountsNewReadingRouteImport } from './routes/_authenticated/silo-counts/new-reading'
import { Route as AuthenticatedSiloCountsCountsRouteImport } from './routes/_authenticated/silo-counts/counts'
import { Route as AuthenticatedSiloCountsCalibrationRouteImport } from './routes/_authenticated/silo-counts/calibration'
import { Route as AuthenticatedSettingsXeroRouteImport } from './routes/_authenticated/settings/xero'
import { Route as AuthenticatedSettingsUsersRouteImport } from './routes/_authenticated/settings/users'
import { Route as AuthenticatedSettingsSitesLocationsRouteImport } from './routes/_authenticated/settings/sites-locations'
import { Route as AuthenticatedSettingsProductsRouteImport } from './routes/_authenticated/settings/products'
import { Route as AuthenticatedSettingsImporterRouteImport } from './routes/_authenticated/settings/importer'
import { Route as AuthenticatedSettingsCostCentresRouteImport } from './routes/_authenticated/settings/cost-centres'
import { Route as AuthenticatedSalesInvoicingSalesOrdersRouteImport } from './routes/_authenticated/sales-invoicing/sales-orders'
import { Route as AuthenticatedSalesInvoicingRaiseRouteImport } from './routes/_authenticated/sales-invoicing/raise'
import { Route as AuthenticatedSalesInvoicingInvoicesRouteImport } from './routes/_authenticated/sales-invoicing/invoices'
import { Route as AuthenticatedSalesInvoicingDispatchesRouteImport } from './routes/_authenticated/sales-invoicing/dispatches'
import { Route as AuthenticatedSalesInvoicingDispatchManualRouteImport } from './routes/_authenticated/sales-invoicing/dispatch-manual'
import { Route as AuthenticatedSalesInvoicingCustomersRouteImport } from './routes/_authenticated/sales-invoicing/customers'
import { Route as AuthenticatedSalesInvoicingCreditNotesRouteImport } from './routes/_authenticated/sales-invoicing/credit-notes'
import { Route as AuthenticatedReportsYieldRouteImport } from './routes/_authenticated/reports/yield'
import { Route as AuthenticatedReportsUninvoicedDispatchesRouteImport } from './routes/_authenticated/reports/uninvoiced-dispatches'
import { Route as AuthenticatedReportsStockOnHandRouteImport } from './routes/_authenticated/reports/stock-on-hand'
import { Route as AuthenticatedReportsSiloDriftRouteImport } from './routes/_authenticated/reports/silo-drift'
import { Route as AuthenticatedReportsSalesRouteImport } from './routes/_authenticated/reports/sales'
import { Route as AuthenticatedReportsReorderRouteImport } from './routes/_authenticated/reports/reorder'
import { Route as AuthenticatedReportsPurchasingRouteImport } from './routes/_authenticated/reports/purchasing'
import { Route as AuthenticatedReportsProductsRouteImport } from './routes/_authenticated/reports/products'
import { Route as AuthenticatedReportsMovementsRouteImport } from './routes/_authenticated/reports/movements'
import { Route as AuthenticatedReportsMassBalanceRouteImport } from './routes/_authenticated/reports/mass-balance'
import { Route as AuthenticatedReportsMarginRouteImport } from './routes/_authenticated/reports/margin'
import { Route as AuthenticatedReportsGenealogyRouteImport } from './routes/_authenticated/reports/genealogy'
import { Route as AuthenticatedReportsConsumableSpendRouteImport } from './routes/_authenticated/reports/consumable-spend'
import { Route as AuthenticatedPurchasingIntakeSuppliersRouteImport } from './routes/_authenticated/purchasing-intake/suppliers'
import { Route as AuthenticatedPurchasingIntakeReorderRouteImport } from './routes/_authenticated/purchasing-intake/reorder'
import { Route as AuthenticatedPurchasingIntakeReceiveManualRouteImport } from './routes/_authenticated/purchasing-intake/receive-manual'
import { Route as AuthenticatedPurchasingIntakeReceiptsRouteImport } from './routes/_authenticated/purchasing-intake/receipts'
import { Route as AuthenticatedPurchasingIntakePurchaseOrdersRouteImport } from './routes/_authenticated/purchasing-intake/purchase-orders'
import { Route as AuthenticatedPurchasingIntakeLandedCostRouteImport } from './routes/_authenticated/purchasing-intake/landed-cost'
import { Route as AuthenticatedPurchasingIntakeContractsRouteImport } from './routes/_authenticated/purchasing-intake/contracts'
import { Route as AuthenticatedProductsProductIdRouteImport } from './routes/_authenticated/products/$productId'
import { Route as AuthenticatedProductionPackconvStagesRouteImport } from './routes/_authenticated/production-packconv/stages'
import { Route as AuthenticatedProductionPackconvRunsRouteImport } from './routes/_authenticated/production-packconv/runs'
import { Route as AuthenticatedProductionPackconvQuickRouteImport } from './routes/_authenticated/production-packconv/quick'
import { Route as AuthenticatedProductionPackconvPackConversionRouteImport } from './routes/_authenticated/production-packconv/pack-conversion'
import { Route as AuthenticatedProductionPackconvBatchesRouteImport } from './routes/_authenticated/production-packconv/batches'
import { Route as AuthenticatedSiloCountsCountsIndexRouteImport } from './routes/_authenticated/silo-counts/counts/index'
import { Route as AuthenticatedSettingsXeroIndexRouteImport } from './routes/_authenticated/settings/xero/index'
import { Route as AuthenticatedSalesInvoicingSalesOrdersIndexRouteImport } from './routes/_authenticated/sales-invoicing/sales-orders/index'
import { Route as AuthenticatedSalesInvoicingInvoicesIndexRouteImport } from './routes/_authenticated/sales-invoicing/invoices/index'
import { Route as AuthenticatedSalesInvoicingDispatchesIndexRouteImport } from './routes/_authenticated/sales-invoicing/dispatches/index'
import { Route as AuthenticatedSalesInvoicingCreditNotesIndexRouteImport } from './routes/_authenticated/sales-invoicing/credit-notes/index'
import { Route as AuthenticatedProductionPackconvRunsIndexRouteImport } from './routes/_authenticated/production-packconv/runs/index'
import { Route as AuthenticatedStoresTransfersTransfersNewRouteImport } from './routes/_authenticated/stores-transfers/transfers.new'
import { Route as AuthenticatedStoresTransfersTransfersTransferIdRouteImport } from './routes/_authenticated/stores-transfers/transfers.$transferId'
import { Route as AuthenticatedStoresTransfersIssuesNewRouteImport } from './routes/_authenticated/stores-transfers/issues.new'
import { Route as AuthenticatedStoresTransfersIssuesIssueIdRouteImport } from './routes/_authenticated/stores-transfers/issues.$issueId'
import { Route as AuthenticatedStoresTransfersAdjustmentsNewRouteImport } from './routes/_authenticated/stores-transfers/adjustments.new'
import { Route as AuthenticatedStoresTransfersAdjustmentsAdjustmentIdRouteImport } from './routes/_authenticated/stores-transfers/adjustments.$adjustmentId'
import { Route as AuthenticatedSiloCountsCountsCountIdRouteImport } from './routes/_authenticated/silo-counts/counts/$countId'
import { Route as AuthenticatedSettingsXeroCallbackRouteImport } from './routes/_authenticated/settings/xero.callback'
import { Route as AuthenticatedSalesInvoicingSalesOrdersNewRouteImport } from './routes/_authenticated/sales-invoicing/sales-orders/new'
import { Route as AuthenticatedSalesInvoicingSalesOrdersSalesOrderIdRouteImport } from './routes/_authenticated/sales-invoicing/sales-orders/$salesOrderId'
import { Route as AuthenticatedSalesInvoicingInvoicesInvoiceIdRouteImport } from './routes/_authenticated/sales-invoicing/invoices/$invoiceId'
import { Route as AuthenticatedSalesInvoicingDispatchesDispatchIdRouteImport } from './routes/_authenticated/sales-invoicing/dispatches/$dispatchId'
import { Route as AuthenticatedSalesInvoicingCreditNotesNewRouteImport } from './routes/_authenticated/sales-invoicing/credit-notes/new'
import { Route as AuthenticatedSalesInvoicingCreditNotesCreditNoteIdRouteImport } from './routes/_authenticated/sales-invoicing/credit-notes/$creditNoteId'
import { Route as AuthenticatedProductionPackconvRunsRunIdRouteImport } from './routes/_authenticated/production-packconv/runs/$runId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth-callback',
  path: '/auth-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedStoresTransfersRoute =
  AuthenticatedStoresTransfersRouteImport.update({
    id: '/stores-transfers',
    path: '/stores-transfers',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSiloCountsRoute = AuthenticatedSiloCountsRouteImport.update({
  id: '/silo-counts',
  path: '/silo-counts',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSearchRoute = AuthenticatedSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSalesInvoicingRoute =
  AuthenticatedSalesInvoicingRouteImport.update({
    id: '/sales-invoicing',
    path: '/sales-invoicing',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPurchasingIntakeRoute =
  AuthenticatedPurchasingIntakeRouteImport.update({
    id: '/purchasing-intake',
    path: '/purchasing-intake',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductionPackconvRoute =
  AuthenticatedProductionPackconvRouteImport.update({
    id: '/production-packconv',
    path: '/production-packconv',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHelpRoute = AuthenticatedHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedStoresTransfersIndexRoute =
  AuthenticatedStoresTransfersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedStoresTransfersRoute,
  } as any)
const AuthenticatedSiloCountsIndexRoute =
  AuthenticatedSiloCountsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSiloCountsRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSalesInvoicingIndexRoute =
  AuthenticatedSalesInvoicingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSalesInvoicingRoute,
  } as any)
const AuthenticatedReportsIndexRoute =
  AuthenticatedReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedPurchasingIntakeIndexRoute =
  AuthenticatedPurchasingIntakeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPurchasingIntakeRoute,
  } as any)
const AuthenticatedProductsIndexRoute =
  AuthenticatedProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductionPackconvIndexRoute =
  AuthenticatedProductionPackconvIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProductionPackconvRoute,
  } as any)
const AuthenticatedSiloCountsStatusRoute =
  AuthenticatedSiloCountsStatusRouteImport.update({
    id: '/status',
    path: '/status',
    getParentRoute: () => AuthenticatedSiloCountsRoute,
  } as any)
const AuthenticatedSiloCountsNewReadingRoute =
  AuthenticatedSiloCountsNewReadingRouteImport.update({
    id: '/new-reading',
    path: '/new-reading',
    getParentRoute: () => AuthenticatedSiloCountsRoute,
  } as any)
const AuthenticatedSiloCountsCountsRoute =
  AuthenticatedSiloCountsCountsRouteImport.update({
    id: '/counts',
    path: '/counts',
    getParentRoute: () => AuthenticatedSiloCountsRoute,
  } as any)
const AuthenticatedSiloCountsCalibrationRoute =
  AuthenticatedSiloCountsCalibrationRouteImport.update({
    id: '/calibration',
    path: '/calibration',
    getParentRoute: () => AuthenticatedSiloCountsRoute,
  } as any)
const AuthenticatedSettingsXeroRoute =
  AuthenticatedSettingsXeroRouteImport.update({
    id: '/xero',
    path: '/xero',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsUsersRoute =
  AuthenticatedSettingsUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsSitesLocationsRoute =
  AuthenticatedSettingsSitesLocationsRouteImport.update({
    id: '/sites-locations',
    path: '/sites-locations',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsProductsRoute =
  AuthenticatedSettingsProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsImporterRoute =
  AuthenticatedSettingsImporterRouteImport.update({
    id: '/importer',
    path: '/importer',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsCostCentresRoute =
  AuthenticatedSettingsCostCentresRouteImport.update({
    id: '/cost-centres',
    path: '/cost-centres',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSalesInvoicingSalesOrdersRoute =
  AuthenticatedSalesInvoicingSalesOrdersRouteImport.update({
    id: '/sales-orders',
    path: '/sales-orders',
    getParentRoute: () => AuthenticatedSalesInvoicingRoute,
  } as any)
const AuthenticatedSalesInvoicingRaiseRoute =
  AuthenticatedSalesInvoicingRaiseRouteImport.update({
    id: '/raise',
    path: '/raise',
    getParentRoute: () => AuthenticatedSalesInvoicingRoute,
  } as any)
const AuthenticatedSalesInvoicingInvoicesRoute =
  AuthenticatedSalesInvoicingInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => AuthenticatedSalesInvoicingRoute,
  } as any)
const AuthenticatedSalesInvoicingDispatchesRoute =
  AuthenticatedSalesInvoicingDispatchesRouteImport.update({
    id: '/dispatches',
    path: '/dispatches',
    getParentRoute: () => AuthenticatedSalesInvoicingRoute,
  } as any)
const AuthenticatedSalesInvoicingDispatchManualRoute =
  AuthenticatedSalesInvoicingDispatchManualRouteImport.update({
    id: '/dispatch-manual',
    path: '/dispatch-manual',
    getParentRoute: () => AuthenticatedSalesInvoicingRoute,
  } as any)
const AuthenticatedSalesInvoicingCustomersRoute =
  AuthenticatedSalesInvoicingCustomersRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => AuthenticatedSalesInvoicingRoute,
  } as any)
const AuthenticatedSalesInvoicingCreditNotesRoute =
  AuthenticatedSalesInvoicingCreditNotesRouteImport.update({
    id: '/credit-notes',
    path: '/credit-notes',
    getParentRoute: () => AuthenticatedSalesInvoicingRoute,
  } as any)
const AuthenticatedReportsYieldRoute =
  AuthenticatedReportsYieldRouteImport.update({
    id: '/yield',
    path: '/yield',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsUninvoicedDispatchesRoute =
  AuthenticatedReportsUninvoicedDispatchesRouteImport.update({
    id: '/uninvoiced-dispatches',
    path: '/uninvoiced-dispatches',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsStockOnHandRoute =
  AuthenticatedReportsStockOnHandRouteImport.update({
    id: '/stock-on-hand',
    path: '/stock-on-hand',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsSiloDriftRoute =
  AuthenticatedReportsSiloDriftRouteImport.update({
    id: '/silo-drift',
    path: '/silo-drift',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsSalesRoute =
  AuthenticatedReportsSalesRouteImport.update({
    id: '/sales',
    path: '/sales',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsReorderRoute =
  AuthenticatedReportsReorderRouteImport.update({
    id: '/reorder',
    path: '/reorder',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsPurchasingRoute =
  AuthenticatedReportsPurchasingRouteImport.update({
    id: '/purchasing',
    path: '/purchasing',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsProductsRoute =
  AuthenticatedReportsProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsMovementsRoute =
  AuthenticatedReportsMovementsRouteImport.update({
    id: '/movements',
    path: '/movements',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsMassBalanceRoute =
  AuthenticatedReportsMassBalanceRouteImport.update({
    id: '/mass-balance',
    path: '/mass-balance',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsMarginRoute =
  AuthenticatedReportsMarginRouteImport.update({
    id: '/margin',
    path: '/margin',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsGenealogyRoute =
  AuthenticatedReportsGenealogyRouteImport.update({
    id: '/genealogy',
    path: '/genealogy',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsConsumableSpendRoute =
  AuthenticatedReportsConsumableSpendRouteImport.update({
    id: '/consumable-spend',
    path: '/consumable-spend',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedPurchasingIntakeSuppliersRoute =
  AuthenticatedPurchasingIntakeSuppliersRouteImport.update({
    id: '/suppliers',
    path: '/suppliers',
    getParentRoute: () => AuthenticatedPurchasingIntakeRoute,
  } as any)
const AuthenticatedPurchasingIntakeReorderRoute =
  AuthenticatedPurchasingIntakeReorderRouteImport.update({
    id: '/reorder',
    path: '/reorder',
    getParentRoute: () => AuthenticatedPurchasingIntakeRoute,
  } as any)
const AuthenticatedPurchasingIntakeReceiveManualRoute =
  AuthenticatedPurchasingIntakeReceiveManualRouteImport.update({
    id: '/receive-manual',
    path: '/receive-manual',
    getParentRoute: () => AuthenticatedPurchasingIntakeRoute,
  } as any)
const AuthenticatedPurchasingIntakeReceiptsRoute =
  AuthenticatedPurchasingIntakeReceiptsRouteImport.update({
    id: '/receipts',
    path: '/receipts',
    getParentRoute: () => AuthenticatedPurchasingIntakeRoute,
  } as any)
const AuthenticatedPurchasingIntakePurchaseOrdersRoute =
  AuthenticatedPurchasingIntakePurchaseOrdersRouteImport.update({
    id: '/purchase-orders',
    path: '/purchase-orders',
    getParentRoute: () => AuthenticatedPurchasingIntakeRoute,
  } as any)
const AuthenticatedPurchasingIntakeLandedCostRoute =
  AuthenticatedPurchasingIntakeLandedCostRouteImport.update({
    id: '/landed-cost',
    path: '/landed-cost',
    getParentRoute: () => AuthenticatedPurchasingIntakeRoute,
  } as any)
const AuthenticatedPurchasingIntakeContractsRoute =
  AuthenticatedPurchasingIntakeContractsRouteImport.update({
    id: '/contracts',
    path: '/contracts',
    getParentRoute: () => AuthenticatedPurchasingIntakeRoute,
  } as any)
const AuthenticatedProductsProductIdRoute =
  AuthenticatedProductsProductIdRouteImport.update({
    id: '/products/$productId',
    path: '/products/$productId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductionPackconvStagesRoute =
  AuthenticatedProductionPackconvStagesRouteImport.update({
    id: '/stages',
    path: '/stages',
    getParentRoute: () => AuthenticatedProductionPackconvRoute,
  } as any)
const AuthenticatedProductionPackconvRunsRoute =
  AuthenticatedProductionPackconvRunsRouteImport.update({
    id: '/runs',
    path: '/runs',
    getParentRoute: () => AuthenticatedProductionPackconvRoute,
  } as any)
const AuthenticatedProductionPackconvQuickRoute =
  AuthenticatedProductionPackconvQuickRouteImport.update({
    id: '/quick',
    path: '/quick',
    getParentRoute: () => AuthenticatedProductionPackconvRoute,
  } as any)
const AuthenticatedProductionPackconvPackConversionRoute =
  AuthenticatedProductionPackconvPackConversionRouteImport.update({
    id: '/pack-conversion',
    path: '/pack-conversion',
    getParentRoute: () => AuthenticatedProductionPackconvRoute,
  } as any)
const AuthenticatedProductionPackconvBatchesRoute =
  AuthenticatedProductionPackconvBatchesRouteImport.update({
    id: '/batches',
    path: '/batches',
    getParentRoute: () => AuthenticatedProductionPackconvRoute,
  } as any)
const AuthenticatedSiloCountsCountsIndexRoute =
  AuthenticatedSiloCountsCountsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSiloCountsCountsRoute,
  } as any)
const AuthenticatedSettingsXeroIndexRoute =
  AuthenticatedSettingsXeroIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsXeroRoute,
  } as any)
const AuthenticatedSalesInvoicingSalesOrdersIndexRoute =
  AuthenticatedSalesInvoicingSalesOrdersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSalesInvoicingSalesOrdersRoute,
  } as any)
const AuthenticatedSalesInvoicingInvoicesIndexRoute =
  AuthenticatedSalesInvoicingInvoicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSalesInvoicingInvoicesRoute,
  } as any)
const AuthenticatedSalesInvoicingDispatchesIndexRoute =
  AuthenticatedSalesInvoicingDispatchesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSalesInvoicingDispatchesRoute,
  } as any)
const AuthenticatedSalesInvoicingCreditNotesIndexRoute =
  AuthenticatedSalesInvoicingCreditNotesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSalesInvoicingCreditNotesRoute,
  } as any)
const AuthenticatedProductionPackconvRunsIndexRoute =
  AuthenticatedProductionPackconvRunsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProductionPackconvRunsRoute,
  } as any)
const AuthenticatedStoresTransfersTransfersNewRoute =
  AuthenticatedStoresTransfersTransfersNewRouteImport.update({
    id: '/transfers/new',
    path: '/transfers/new',
    getParentRoute: () => AuthenticatedStoresTransfersRoute,
  } as any)
const AuthenticatedStoresTransfersTransfersTransferIdRoute =
  AuthenticatedStoresTransfersTransfersTransferIdRouteImport.update({
    id: '/transfers/$transferId',
    path: '/transfers/$transferId',
    getParentRoute: () => AuthenticatedStoresTransfersRoute,
  } as any)
const AuthenticatedStoresTransfersIssuesNewRoute =
  AuthenticatedStoresTransfersIssuesNewRouteImport.update({
    id: '/issues/new',
    path: '/issues/new',
    getParentRoute: () => AuthenticatedStoresTransfersRoute,
  } as any)
const AuthenticatedStoresTransfersIssuesIssueIdRoute =
  AuthenticatedStoresTransfersIssuesIssueIdRouteImport.update({
    id: '/issues/$issueId',
    path: '/issues/$issueId',
    getParentRoute: () => AuthenticatedStoresTransfersRoute,
  } as any)
const AuthenticatedStoresTransfersAdjustmentsNewRoute =
  AuthenticatedStoresTransfersAdjustmentsNewRouteImport.update({
    id: '/adjustments/new',
    path: '/adjustments/new',
    getParentRoute: () => AuthenticatedStoresTransfersRoute,
  } as any)
const AuthenticatedStoresTransfersAdjustmentsAdjustmentIdRoute =
  AuthenticatedStoresTransfersAdjustmentsAdjustmentIdRouteImport.update({
    id: '/adjustments/$adjustmentId',
    path: '/adjustments/$adjustmentId',
    getParentRoute: () => AuthenticatedStoresTransfersRoute,
  } as any)
const AuthenticatedSiloCountsCountsCountIdRoute =
  AuthenticatedSiloCountsCountsCountIdRouteImport.update({
    id: '/$countId',
    path: '/$countId',
    getParentRoute: () => AuthenticatedSiloCountsCountsRoute,
  } as any)
const AuthenticatedSettingsXeroCallbackRoute =
  AuthenticatedSettingsXeroCallbackRouteImport.update({
    id: '/callback',
    path: '/callback',
    getParentRoute: () => AuthenticatedSettingsXeroRoute,
  } as any)
const AuthenticatedSalesInvoicingSalesOrdersNewRoute =
  AuthenticatedSalesInvoicingSalesOrdersNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedSalesInvoicingSalesOrdersRoute,
  } as any)
const AuthenticatedSalesInvoicingSalesOrdersSalesOrderIdRoute =
  AuthenticatedSalesInvoicingSalesOrdersSalesOrderIdRouteImport.update({
    id: '/$salesOrderId',
    path: '/$salesOrderId',
    getParentRoute: () => AuthenticatedSalesInvoicingSalesOrdersRoute,
  } as any)
const AuthenticatedSalesInvoicingInvoicesInvoiceIdRoute =
  AuthenticatedSalesInvoicingInvoicesInvoiceIdRouteImport.update({
    id: '/$invoiceId',
    path: '/$invoiceId',
    getParentRoute: () => AuthenticatedSalesInvoicingInvoicesRoute,
  } as any)
const AuthenticatedSalesInvoicingDispatchesDispatchIdRoute =
  AuthenticatedSalesInvoicingDispatchesDispatchIdRouteImport.update({
    id: '/$dispatchId',
    path: '/$dispatchId',
    getParentRoute: () => AuthenticatedSalesInvoicingDispatchesRoute,
  } as any)
const AuthenticatedSalesInvoicingCreditNotesNewRoute =
  AuthenticatedSalesInvoicingCreditNotesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedSalesInvoicingCreditNotesRoute,
  } as any)
const AuthenticatedSalesInvoicingCreditNotesCreditNoteIdRoute =
  AuthenticatedSalesInvoicingCreditNotesCreditNoteIdRouteImport.update({
    id: '/$creditNoteId',
    path: '/$creditNoteId',
    getParentRoute: () => AuthenticatedSalesInvoicingCreditNotesRoute,
  } as any)
const AuthenticatedProductionPackconvRunsRunIdRoute =
  AuthenticatedProductionPackconvRunsRunIdRouteImport.update({
    id: '/$runId',
    path: '/$runId',
    getParentRoute: () => AuthenticatedProductionPackconvRunsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/auth-callback': typeof AuthCallbackRoute
  '/login': typeof LoginRoute
  '/help': typeof AuthenticatedHelpRoute
  '/production-packconv': typeof AuthenticatedProductionPackconvRouteWithChildren
  '/purchasing-intake': typeof AuthenticatedPurchasingIntakeRouteWithChildren
  '/reports': typeof AuthenticatedReportsRouteWithChildren
  '/sales-invoicing': typeof AuthenticatedSalesInvoicingRouteWithChildren
  '/search': typeof AuthenticatedSearchRoute
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/silo-counts': typeof AuthenticatedSiloCountsRouteWithChildren
  '/stores-transfers': typeof AuthenticatedStoresTransfersRouteWithChildren
  '/production-packconv/batches': typeof AuthenticatedProductionPackconvBatchesRoute
  '/production-packconv/pack-conversion': typeof AuthenticatedProductionPackconvPackConversionRoute
  '/production-packconv/quick': typeof AuthenticatedProductionPackconvQuickRoute
  '/production-packconv/runs': typeof AuthenticatedProductionPackconvRunsRouteWithChildren
  '/production-packconv/stages': typeof AuthenticatedProductionPackconvStagesRoute
  '/products/$productId': typeof AuthenticatedProductsProductIdRoute
  '/purchasing-intake/contracts': typeof AuthenticatedPurchasingIntakeContractsRoute
  '/purchasing-intake/landed-cost': typeof AuthenticatedPurchasingIntakeLandedCostRoute
  '/purchasing-intake/purchase-orders': typeof AuthenticatedPurchasingIntakePurchaseOrdersRoute
  '/purchasing-intake/receipts': typeof AuthenticatedPurchasingIntakeReceiptsRoute
  '/purchasing-intake/receive-manual': typeof AuthenticatedPurchasingIntakeReceiveManualRoute
  '/purchasing-intake/reorder': typeof AuthenticatedPurchasingIntakeReorderRoute
  '/purchasing-intake/suppliers': typeof AuthenticatedPurchasingIntakeSuppliersRoute
  '/reports/consumable-spend': typeof AuthenticatedReportsConsumableSpendRoute
  '/reports/genealogy': typeof AuthenticatedReportsGenealogyRoute
  '/reports/margin': typeof AuthenticatedReportsMarginRoute
  '/reports/mass-balance': typeof AuthenticatedReportsMassBalanceRoute
  '/reports/movements': typeof AuthenticatedReportsMovementsRoute
  '/reports/products': typeof AuthenticatedReportsProductsRoute
  '/reports/purchasing': typeof AuthenticatedReportsPurchasingRoute
  '/reports/reorder': typeof AuthenticatedReportsReorderRoute
  '/reports/sales': typeof AuthenticatedReportsSalesRoute
  '/reports/silo-drift': typeof AuthenticatedReportsSiloDriftRoute
  '/reports/stock-on-hand': typeof AuthenticatedReportsStockOnHandRoute
  '/reports/uninvoiced-dispatches': typeof AuthenticatedReportsUninvoicedDispatchesRoute
  '/reports/yield': typeof AuthenticatedReportsYieldRoute
  '/sales-invoicing/credit-notes': typeof AuthenticatedSalesInvoicingCreditNotesRouteWithChildren
  '/sales-invoicing/customers': typeof AuthenticatedSalesInvoicingCustomersRoute
  '/sales-invoicing/dispatch-manual': typeof AuthenticatedSalesInvoicingDispatchManualRoute
  '/sales-invoicing/dispatches': typeof AuthenticatedSalesInvoicingDispatchesRouteWithChildren
  '/sales-invoicing/invoices': typeof AuthenticatedSalesInvoicingInvoicesRouteWithChildren
  '/sales-invoicing/raise': typeof AuthenticatedSalesInvoicingRaiseRoute
  '/sales-invoicing/sales-orders': typeof AuthenticatedSalesInvoicingSalesOrdersRouteWithChildren
  '/settings/cost-centres': typeof AuthenticatedSettingsCostCentresRoute
  '/settings/importer': typeof AuthenticatedSettingsImporterRoute
  '/settings/products': typeof AuthenticatedSettingsProductsRoute
  '/settings/sites-locations': typeof AuthenticatedSettingsSitesLocationsRoute
  '/settings/users': typeof AuthenticatedSettingsUsersRoute
  '/settings/xero': typeof AuthenticatedSettingsXeroRouteWithChildren
  '/silo-counts/calibration': typeof AuthenticatedSiloCountsCalibrationRoute
  '/silo-counts/counts': typeof AuthenticatedSiloCountsCountsRouteWithChildren
  '/silo-counts/new-reading': typeof AuthenticatedSiloCountsNewReadingRoute
  '/silo-counts/status': typeof AuthenticatedSiloCountsStatusRoute
  '/production-packconv/': typeof AuthenticatedProductionPackconvIndexRoute
  '/products/': typeof AuthenticatedProductsIndexRoute
  '/purchasing-intake/': typeof AuthenticatedPurchasingIntakeIndexRoute
  '/reports/': typeof AuthenticatedReportsIndexRoute
  '/sales-invoicing/': typeof AuthenticatedSalesInvoicingIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/silo-counts/': typeof AuthenticatedSiloCountsIndexRoute
  '/stores-transfers/': typeof AuthenticatedStoresTransfersIndexRoute
  '/production-packconv/runs/$runId': typeof AuthenticatedProductionPackconvRunsRunIdRoute
  '/sales-invoicing/credit-notes/$creditNoteId': typeof AuthenticatedSalesInvoicingCreditNotesCreditNoteIdRoute
  '/sales-invoicing/credit-notes/new': typeof AuthenticatedSalesInvoicingCreditNotesNewRoute
  '/sales-invoicing/dispatches/$dispatchId': typeof AuthenticatedSalesInvoicingDispatchesDispatchIdRoute
  '/sales-invoicing/invoices/$invoiceId': typeof AuthenticatedSalesInvoicingInvoicesInvoiceIdRoute
  '/sales-invoicing/sales-orders/$salesOrderId': typeof AuthenticatedSalesInvoicingSalesOrdersSalesOrderIdRoute
  '/sales-invoicing/sales-orders/new': typeof AuthenticatedSalesInvoicingSalesOrdersNewRoute
  '/settings/xero/callback': typeof AuthenticatedSettingsXeroCallbackRoute
  '/silo-counts/counts/$countId': typeof AuthenticatedSiloCountsCountsCountIdRoute
  '/stores-transfers/adjustments/$adjustmentId': typeof AuthenticatedStoresTransfersAdjustmentsAdjustmentIdRoute
  '/stores-transfers/adjustments/new': typeof AuthenticatedStoresTransfersAdjustmentsNewRoute
  '/stores-transfers/issues/$issueId': typeof AuthenticatedStoresTransfersIssuesIssueIdRoute
  '/stores-transfers/issues/new': typeof AuthenticatedStoresTransfersIssuesNewRoute
  '/stores-transfers/transfers/$transferId': typeof AuthenticatedStoresTransfersTransfersTransferIdRoute
  '/stores-transfers/transfers/new': typeof AuthenticatedStoresTransfersTransfersNewRoute
  '/production-packconv/runs/': typeof AuthenticatedProductionPackconvRunsIndexRoute
  '/sales-invoicing/credit-notes/': typeof AuthenticatedSalesInvoicingCreditNotesIndexRoute
  '/sales-invoicing/dispatches/': typeof AuthenticatedSalesInvoicingDispatchesIndexRoute
  '/sales-invoicing/invoices/': typeof AuthenticatedSalesInvoicingInvoicesIndexRoute
  '/sales-invoicing/sales-orders/': typeof AuthenticatedSalesInvoicingSalesOrdersIndexRoute
  '/settings/xero/': typeof AuthenticatedSettingsXeroIndexRoute
  '/silo-counts/counts/': typeof AuthenticatedSiloCountsCountsIndexRoute
}
export interface FileRoutesByTo {
  '/auth-callback': typeof AuthCallbackRoute
  '/login': typeof LoginRoute
  '/help': typeof AuthenticatedHelpRoute
  '/search': typeof AuthenticatedSearchRoute
  '/': typeof AuthenticatedIndexRoute
  '/production-packconv/batches': typeof AuthenticatedProductionPackconvBatchesRoute
  '/production-packconv/pack-conversion': typeof AuthenticatedProductionPackconvPackConversionRoute
  '/production-packconv/quick': typeof AuthenticatedProductionPackconvQuickRoute
  '/production-packconv/stages': typeof AuthenticatedProductionPackconvStagesRoute
  '/products/$productId': typeof AuthenticatedProductsProductIdRoute
  '/purchasing-intake/contracts': typeof AuthenticatedPurchasingIntakeContractsRoute
  '/purchasing-intake/landed-cost': typeof AuthenticatedPurchasingIntakeLandedCostRoute
  '/purchasing-intake/purchase-orders': typeof AuthenticatedPurchasingIntakePurchaseOrdersRoute
  '/purchasing-intake/receipts': typeof AuthenticatedPurchasingIntakeReceiptsRoute
  '/purchasing-intake/receive-manual': typeof AuthenticatedPurchasingIntakeReceiveManualRoute
  '/purchasing-intake/reorder': typeof AuthenticatedPurchasingIntakeReorderRoute
  '/purchasing-intake/suppliers': typeof AuthenticatedPurchasingIntakeSuppliersRoute
  '/reports/consumable-spend': typeof AuthenticatedReportsConsumableSpendRoute
  '/reports/genealogy': typeof AuthenticatedReportsGenealogyRoute
  '/reports/margin': typeof AuthenticatedReportsMarginRoute
  '/reports/mass-balance': typeof AuthenticatedReportsMassBalanceRoute
  '/reports/movements': typeof AuthenticatedReportsMovementsRoute
  '/reports/products': typeof AuthenticatedReportsProductsRoute
  '/reports/purchasing': typeof AuthenticatedReportsPurchasingRoute
  '/reports/reorder': typeof AuthenticatedReportsReorderRoute
  '/reports/sales': typeof AuthenticatedReportsSalesRoute
  '/reports/silo-drift': typeof AuthenticatedReportsSiloDriftRoute
  '/reports/stock-on-hand': typeof AuthenticatedReportsStockOnHandRoute
  '/reports/uninvoiced-dispatches': typeof AuthenticatedReportsUninvoicedDispatchesRoute
  '/reports/yield': typeof AuthenticatedReportsYieldRoute
  '/sales-invoicing/customers': typeof AuthenticatedSalesInvoicingCustomersRoute
  '/sales-invoicing/dispatch-manual': typeof AuthenticatedSalesInvoicingDispatchManualRoute
  '/sales-invoicing/raise': typeof AuthenticatedSalesInvoicingRaiseRoute
  '/settings/cost-centres': typeof AuthenticatedSettingsCostCentresRoute
  '/settings/importer': typeof AuthenticatedSettingsImporterRoute
  '/settings/products': typeof AuthenticatedSettingsProductsRoute
  '/settings/sites-locations': typeof AuthenticatedSettingsSitesLocationsRoute
  '/settings/users': typeof AuthenticatedSettingsUsersRoute
  '/silo-counts/calibration': typeof AuthenticatedSiloCountsCalibrationRoute
  '/silo-counts/new-reading': typeof AuthenticatedSiloCountsNewReadingRoute
  '/silo-counts/status': typeof AuthenticatedSiloCountsStatusRoute
  '/production-packconv': typeof AuthenticatedProductionPackconvIndexRoute
  '/products': typeof AuthenticatedProductsIndexRoute
  '/purchasing-intake': typeof AuthenticatedPurchasingIntakeIndexRoute
  '/reports': typeof AuthenticatedReportsIndexRoute
  '/sales-invoicing': typeof AuthenticatedSalesInvoicingIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/silo-counts': typeof AuthenticatedSiloCountsIndexRoute
  '/stores-transfers': typeof AuthenticatedStoresTransfersIndexRoute
  '/production-packconv/runs/$runId': typeof AuthenticatedProductionPackconvRunsRunIdRoute
  '/sales-invoicing/credit-notes/$creditNoteId': typeof AuthenticatedSalesInvoicingCreditNotesCreditNoteIdRoute
  '/sales-invoicing/credit-notes/new': typeof AuthenticatedSalesInvoicingCreditNotesNewRoute
  '/sales-invoicing/dispatches/$dispatchId': typeof AuthenticatedSalesInvoicingDispatchesDispatchIdRoute
  '/sales-invoicing/invoices/$invoiceId': typeof AuthenticatedSalesInvoicingInvoicesInvoiceIdRoute
  '/sales-invoicing/sales-orders/$salesOrderId': typeof AuthenticatedSalesInvoicingSalesOrdersSalesOrderIdRoute
  '/sales-invoicing/sales-orders/new': typeof AuthenticatedSalesInvoicingSalesOrdersNewRoute
  '/settings/xero/callback': typeof AuthenticatedSettingsXeroCallbackRoute
  '/silo-counts/counts/$countId': typeof AuthenticatedSiloCountsCountsCountIdRoute
  '/stores-transfers/adjustments/$adjustmentId': typeof AuthenticatedStoresTransfersAdjustmentsAdjustmentIdRoute
  '/stores-transfers/adjustments/new': typeof AuthenticatedStoresTransfersAdjustmentsNewRoute
  '/stores-transfers/issues/$issueId': typeof AuthenticatedStoresTransfersIssuesIssueIdRoute
  '/stores-transfers/issues/new': typeof AuthenticatedStoresTransfersIssuesNewRoute
  '/stores-transfers/transfers/$transferId': typeof AuthenticatedStoresTransfersTransfersTransferIdRoute
  '/stores-transfers/transfers/new': typeof AuthenticatedStoresTransfersTransfersNewRoute
  '/production-packconv/runs': typeof AuthenticatedProductionPackconvRunsIndexRoute
  '/sales-invoicing/credit-notes': typeof AuthenticatedSalesInvoicingCreditNotesIndexRoute
  '/sales-invoicing/dispatches': typeof AuthenticatedSalesInvoicingDispatchesIndexRoute
  '/sales-invoicing/invoices': typeof AuthenticatedSalesInvoicingInvoicesIndexRoute
  '/sales-invoicing/sales-orders': typeof AuthenticatedSalesInvoicingSalesOrdersIndexRoute
  '/settings/xero': typeof AuthenticatedSettingsXeroIndexRoute
  '/silo-counts/counts': typeof AuthenticatedSiloCountsCountsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/auth-callback': typeof AuthCallbackRoute
  '/login': typeof LoginRoute
  '/_authenticated/help': typeof AuthenticatedHelpRoute
  '/_authenticated/production-packconv': typeof AuthenticatedProductionPackconvRouteWithChildren
  '/_authenticated/purchasing-intake': typeof AuthenticatedPurchasingIntakeRouteWithChildren
  '/_authenticated/reports': typeof AuthenticatedReportsRouteWithChildren
  '/_authenticated/sales-invoicing': typeof AuthenticatedSalesInvoicingRouteWithChildren
  '/_authenticated/search': typeof AuthenticatedSearchRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/_authenticated/silo-counts': typeof AuthenticatedSiloCountsRouteWithChildren
  '/_authenticated/stores-transfers': typeof AuthenticatedStoresTransfersRouteWithChildren
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/production-packconv/batches': typeof AuthenticatedProductionPackconvBatchesRoute
  '/_authenticated/production-packconv/pack-conversion': typeof AuthenticatedProductionPackconvPackConversionRoute
  '/_authenticated/production-packconv/quick': typeof AuthenticatedProductionPackconvQuickRoute
  '/_authenticated/production-packconv/runs': typeof AuthenticatedProductionPackconvRunsRouteWithChildren
  '/_authenticated/production-packconv/stages': typeof AuthenticatedProductionPackconvStagesRoute
  '/_authenticated/products/$productId': typeof AuthenticatedProductsProductIdRoute
  '/_authenticated/purchasing-intake/contracts': typeof AuthenticatedPurchasingIntakeContractsRoute
  '/_authenticated/purchasing-intake/landed-cost': typeof AuthenticatedPurchasingIntakeLandedCostRoute
  '/_authenticated/purchasing-intake/purchase-orders': typeof AuthenticatedPurchasingIntakePurchaseOrdersRoute
  '/_authenticated/purchasing-intake/receipts': typeof AuthenticatedPurchasingIntakeReceiptsRoute
  '/_authenticated/purchasing-intake/receive-manual': typeof AuthenticatedPurchasingIntakeReceiveManualRoute
  '/_authenticated/purchasing-intake/reorder': typeof AuthenticatedPurchasingIntakeReorderRoute
  '/_authenticated/purchasing-intake/suppliers': typeof AuthenticatedPurchasingIntakeSuppliersRoute
  '/_authenticated/reports/consumable-spend': typeof AuthenticatedReportsConsumableSpendRoute
  '/_authenticated/reports/genealogy': typeof AuthenticatedReportsGenealogyRoute
  '/_authenticated/reports/margin': typeof AuthenticatedReportsMarginRoute
  '/_authenticated/reports/mass-balance': typeof AuthenticatedReportsMassBalanceRoute
  '/_authenticated/reports/movements': typeof AuthenticatedReportsMovementsRoute
  '/_authenticated/reports/products': typeof AuthenticatedReportsProductsRoute
  '/_authenticated/reports/purchasing': typeof AuthenticatedReportsPurchasingRoute
  '/_authenticated/reports/reorder': typeof AuthenticatedReportsReorderRoute
  '/_authenticated/reports/sales': typeof AuthenticatedReportsSalesRoute
  '/_authenticated/reports/silo-drift': typeof AuthenticatedReportsSiloDriftRoute
  '/_authenticated/reports/stock-on-hand': typeof AuthenticatedReportsStockOnHandRoute
  '/_authenticated/reports/uninvoiced-dispatches': typeof AuthenticatedReportsUninvoicedDispatchesRoute
  '/_authenticated/reports/yield': typeof AuthenticatedReportsYieldRoute
  '/_authenticated/sales-invoicing/credit-notes': typeof AuthenticatedSalesInvoicingCreditNotesRouteWithChildren
  '/_authenticated/sales-invoicing/customers': typeof AuthenticatedSalesInvoicingCustomersRoute
  '/_authenticated/sales-invoicing/dispatch-manual': typeof AuthenticatedSalesInvoicingDispatchManualRoute
  '/_authenticated/sales-invoicing/dispatches': typeof AuthenticatedSalesInvoicingDispatchesRouteWithChildren
  '/_authenticated/sales-invoicing/invoices': typeof AuthenticatedSalesInvoicingInvoicesRouteWithChildren
  '/_authenticated/sales-invoicing/raise': typeof AuthenticatedSalesInvoicingRaiseRoute
  '/_authenticated/sales-invoicing/sales-orders': typeof AuthenticatedSalesInvoicingSalesOrdersRouteWithChildren
  '/_authenticated/settings/cost-centres': typeof AuthenticatedSettingsCostCentresRoute
  '/_authenticated/settings/importer': typeof AuthenticatedSettingsImporterRoute
  '/_authenticated/settings/products': typeof AuthenticatedSettingsProductsRoute
  '/_authenticated/settings/sites-locations': typeof AuthenticatedSettingsSitesLocationsRoute
  '/_authenticated/settings/users': typeof AuthenticatedSettingsUsersRoute
  '/_authenticated/settings/xero': typeof AuthenticatedSettingsXeroRouteWithChildren
  '/_authenticated/silo-counts/calibration': typeof AuthenticatedSiloCountsCalibrationRoute
  '/_authenticated/silo-counts/counts': typeof AuthenticatedSiloCountsCountsRouteWithChildren
  '/_authenticated/silo-counts/new-reading': typeof AuthenticatedSiloCountsNewReadingRoute
  '/_authenticated/silo-counts/status': typeof AuthenticatedSiloCountsStatusRoute
  '/_authenticated/production-packconv/': typeof AuthenticatedProductionPackconvIndexRoute
  '/_authenticated/products/': typeof AuthenticatedProductsIndexRoute
  '/_authenticated/purchasing-intake/': typeof AuthenticatedPurchasingIntakeIndexRoute
  '/_authenticated/reports/': typeof AuthenticatedReportsIndexRoute
  '/_authenticated/sales-invoicing/': typeof AuthenticatedSalesInvoicingIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/silo-counts/': typeof AuthenticatedSiloCountsIndexRoute
  '/_authenticated/stores-transfers/': typeof AuthenticatedStoresTransfersIndexRoute
  '/_authenticated/production-packconv/runs/$runId': typeof AuthenticatedProductionPackconvRunsRunIdRoute
  '/_authenticated/sales-invoicing/credit-notes/$creditNoteId': typeof AuthenticatedSalesInvoicingCreditNotesCreditNoteIdRoute
  '/_authenticated/sales-invoicing/credit-notes/new': typeof AuthenticatedSalesInvoicingCreditNotesNewRoute
  '/_authenticated/sales-invoicing/dispatches/$dispatchId': typeof AuthenticatedSalesInvoicingDispatchesDispatchIdRoute
  '/_authenticated/sales-invoicing/invoices/$invoiceId': typeof AuthenticatedSalesInvoicingInvoicesInvoiceIdRoute
  '/_authenticated/sales-invoicing/sales-orders/$salesOrderId': typeof AuthenticatedSalesInvoicingSalesOrdersSalesOrderIdRoute
  '/_authenticated/sales-invoicing/sales-orders/new': typeof AuthenticatedSalesInvoicingSalesOrdersNewRoute
  '/_authenticated/settings/xero/callback': typeof AuthenticatedSettingsXeroCallbackRoute
  '/_authenticated/silo-counts/counts/$countId': typeof AuthenticatedSiloCountsCountsCountIdRoute
  '/_authenticated/stores-transfers/adjustments/$adjustmentId': typeof AuthenticatedStoresTransfersAdjustmentsAdjustmentIdRoute
  '/_authenticated/stores-transfers/adjustments/new': typeof AuthenticatedStoresTransfersAdjustmentsNewRoute
  '/_authenticated/stores-transfers/issues/$issueId': typeof AuthenticatedStoresTransfersIssuesIssueIdRoute
  '/_authenticated/stores-transfers/issues/new': typeof AuthenticatedStoresTransfersIssuesNewRoute
  '/_authenticated/stores-transfers/transfers/$transferId': typeof AuthenticatedStoresTransfersTransfersTransferIdRoute
  '/_authenticated/stores-transfers/transfers/new': typeof AuthenticatedStoresTransfersTransfersNewRoute
  '/_authenticated/production-packconv/runs/': typeof AuthenticatedProductionPackconvRunsIndexRoute
  '/_authenticated/sales-invoicing/credit-notes/': typeof AuthenticatedSalesInvoicingCreditNotesIndexRoute
  '/_authenticated/sales-invoicing/dispatches/': typeof AuthenticatedSalesInvoicingDispatchesIndexRoute
  '/_authenticated/sales-invoicing/invoices/': typeof AuthenticatedSalesInvoicingInvoicesIndexRoute
  '/_authenticated/sales-invoicing/sales-orders/': typeof AuthenticatedSalesInvoicingSalesOrdersIndexRoute
  '/_authenticated/settings/xero/': typeof AuthenticatedSettingsXeroIndexRoute
  '/_authenticated/silo-counts/counts/': typeof AuthenticatedSiloCountsCountsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth-callback'
    | '/login'
    | '/help'
    | '/production-packconv'
    | '/purchasing-intake'
    | '/reports'
    | '/sales-invoicing'
    | '/search'
    | '/settings'
    | '/silo-counts'
    | '/stores-transfers'
    | '/production-packconv/batches'
    | '/production-packconv/pack-conversion'
    | '/production-packconv/quick'
    | '/production-packconv/runs'
    | '/production-packconv/stages'
    | '/products/$productId'
    | '/purchasing-intake/contracts'
    | '/purchasing-intake/landed-cost'
    | '/purchasing-intake/purchase-orders'
    | '/purchasing-intake/receipts'
    | '/purchasing-intake/receive-manual'
    | '/purchasing-intake/reorder'
    | '/purchasing-intake/suppliers'
    | '/reports/consumable-spend'
    | '/reports/genealogy'
    | '/reports/margin'
    | '/reports/mass-balance'
    | '/reports/movements'
    | '/reports/products'
    | '/reports/purchasing'
    | '/reports/reorder'
    | '/reports/sales'
    | '/reports/silo-drift'
    | '/reports/stock-on-hand'
    | '/reports/uninvoiced-dispatches'
    | '/reports/yield'
    | '/sales-invoicing/credit-notes'
    | '/sales-invoicing/customers'
    | '/sales-invoicing/dispatch-manual'
    | '/sales-invoicing/dispatches'
    | '/sales-invoicing/invoices'
    | '/sales-invoicing/raise'
    | '/sales-invoicing/sales-orders'
    | '/settings/cost-centres'
    | '/settings/importer'
    | '/settings/products'
    | '/settings/sites-locations'
    | '/settings/users'
    | '/settings/xero'
    | '/silo-counts/calibration'
    | '/silo-counts/counts'
    | '/silo-counts/new-reading'
    | '/silo-counts/status'
    | '/production-packconv/'
    | '/products/'
    | '/purchasing-intake/'
    | '/reports/'
    | '/sales-invoicing/'
    | '/settings/'
    | '/silo-counts/'
    | '/stores-transfers/'
    | '/production-packconv/runs/$runId'
    | '/sales-invoicing/credit-notes/$creditNoteId'
    | '/sales-invoicing/credit-notes/new'
    | '/sales-invoicing/dispatches/$dispatchId'
    | '/sales-invoicing/invoices/$invoiceId'
    | '/sales-invoicing/sales-orders/$salesOrderId'
    | '/sales-invoicing/sales-orders/new'
    | '/settings/xero/callback'
    | '/silo-counts/counts/$countId'
    | '/stores-transfers/adjustments/$adjustmentId'
    | '/stores-transfers/adjustments/new'
    | '/stores-transfers/issues/$issueId'
    | '/stores-transfers/issues/new'
    | '/stores-transfers/transfers/$transferId'
    | '/stores-transfers/transfers/new'
    | '/production-packconv/runs/'
    | '/sales-invoicing/credit-notes/'
    | '/sales-invoicing/dispatches/'
    | '/sales-invoicing/invoices/'
    | '/sales-invoicing/sales-orders/'
    | '/settings/xero/'
    | '/silo-counts/counts/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth-callback'
    | '/login'
    | '/help'
    | '/search'
    | '/'
    | '/production-packconv/batches'
    | '/production-packconv/pack-conversion'
    | '/production-packconv/quick'
    | '/production-packconv/stages'
    | '/products/$productId'
    | '/purchasing-intake/contracts'
    | '/purchasing-intake/landed-cost'
    | '/purchasing-intake/purchase-orders'
    | '/purchasing-intake/receipts'
    | '/purchasing-intake/receive-manual'
    | '/purchasing-intake/reorder'
    | '/purchasing-intake/suppliers'
    | '/reports/consumable-spend'
    | '/reports/genealogy'
    | '/reports/margin'
    | '/reports/mass-balance'
    | '/reports/movements'
    | '/reports/products'
    | '/reports/purchasing'
    | '/reports/reorder'
    | '/reports/sales'
    | '/reports/silo-drift'
    | '/reports/stock-on-hand'
    | '/reports/uninvoiced-dispatches'
    | '/reports/yield'
    | '/sales-invoicing/customers'
    | '/sales-invoicing/dispatch-manual'
    | '/sales-invoicing/raise'
    | '/settings/cost-centres'
    | '/settings/importer'
    | '/settings/products'
    | '/settings/sites-locations'
    | '/settings/users'
    | '/silo-counts/calibration'
    | '/silo-counts/new-reading'
    | '/silo-counts/status'
    | '/production-packconv'
    | '/products'
    | '/purchasing-intake'
    | '/reports'
    | '/sales-invoicing'
    | '/settings'
    | '/silo-counts'
    | '/stores-transfers'
    | '/production-packconv/runs/$runId'
    | '/sales-invoicing/credit-notes/$creditNoteId'
    | '/sales-invoicing/credit-notes/new'
    | '/sales-invoicing/dispatches/$dispatchId'
    | '/sales-invoicing/invoices/$invoiceId'
    | '/sales-invoicing/sales-orders/$salesOrderId'
    | '/sales-invoicing/sales-orders/new'
    | '/settings/xero/callback'
    | '/silo-counts/counts/$countId'
    | '/stores-transfers/adjustments/$adjustmentId'
    | '/stores-transfers/adjustments/new'
    | '/stores-transfers/issues/$issueId'
    | '/stores-transfers/issues/new'
    | '/stores-transfers/transfers/$transferId'
    | '/stores-transfers/transfers/new'
    | '/production-packconv/runs'
    | '/sales-invoicing/credit-notes'
    | '/sales-invoicing/dispatches'
    | '/sales-invoicing/invoices'
    | '/sales-invoicing/sales-orders'
    | '/settings/xero'
    | '/silo-counts/counts'
  id:
    | '__root__'
    | '/_authenticated'
    | '/auth-callback'
    | '/login'
    | '/_authenticated/help'
    | '/_authenticated/production-packconv'
    | '/_authenticated/purchasing-intake'
    | '/_authenticated/reports'
    | '/_authenticated/sales-invoicing'
    | '/_authenticated/search'
    | '/_authenticated/settings'
    | '/_authenticated/silo-counts'
    | '/_authenticated/stores-transfers'
    | '/_authenticated/'
    | '/_authenticated/production-packconv/batches'
    | '/_authenticated/production-packconv/pack-conversion'
    | '/_authenticated/production-packconv/quick'
    | '/_authenticated/production-packconv/runs'
    | '/_authenticated/production-packconv/stages'
    | '/_authenticated/products/$productId'
    | '/_authenticated/purchasing-intake/contracts'
    | '/_authenticated/purchasing-intake/landed-cost'
    | '/_authenticated/purchasing-intake/purchase-orders'
    | '/_authenticated/purchasing-intake/receipts'
    | '/_authenticated/purchasing-intake/receive-manual'
    | '/_authenticated/purchasing-intake/reorder'
    | '/_authenticated/purchasing-intake/suppliers'
    | '/_authenticated/reports/consumable-spend'
    | '/_authenticated/reports/genealogy'
    | '/_authenticated/reports/margin'
    | '/_authenticated/reports/mass-balance'
    | '/_authenticated/reports/movements'
    | '/_authenticated/reports/products'
    | '/_authenticated/reports/purchasing'
    | '/_authenticated/reports/reorder'
    | '/_authenticated/reports/sales'
    | '/_authenticated/reports/silo-drift'
    | '/_authenticated/reports/stock-on-hand'
    | '/_authenticated/reports/uninvoiced-dispatches'
    | '/_authenticated/reports/yield'
    | '/_authenticated/sales-invoicing/credit-notes'
    | '/_authenticated/sales-invoicing/customers'
    | '/_authenticated/sales-invoicing/dispatch-manual'
    | '/_authenticated/sales-invoicing/dispatches'
    | '/_authenticated/sales-invoicing/invoices'
    | '/_authenticated/sales-invoicing/raise'
    | '/_authenticated/sales-invoicing/sales-orders'
    | '/_authenticated/settings/cost-centres'
    | '/_authenticated/settings/importer'
    | '/_authenticated/settings/products'
    | '/_authenticated/settings/sites-locations'
    | '/_authenticated/settings/users'
    | '/_authenticated/settings/xero'
    | '/_authenticated/silo-counts/calibration'
    | '/_authenticated/silo-counts/counts'
    | '/_authenticated/silo-counts/new-reading'
    | '/_authenticated/silo-counts/status'
    | '/_authenticated/production-packconv/'
    | '/_authenticated/products/'
    | '/_authenticated/purchasing-intake/'
    | '/_authenticated/reports/'
    | '/_authenticated/sales-invoicing/'
    | '/_authenticated/settings/'
    | '/_authenticated/silo-counts/'
    | '/_authenticated/stores-transfers/'
    | '/_authenticated/production-packconv/runs/$runId'
    | '/_authenticated/sales-invoicing/credit-notes/$creditNoteId'
    | '/_authenticated/sales-invoicing/credit-notes/new'
    | '/_authenticated/sales-invoicing/dispatches/$dispatchId'
    | '/_authenticated/sales-invoicing/invoices/$invoiceId'
    | '/_authenticated/sales-invoicing/sales-orders/$salesOrderId'
    | '/_authenticated/sales-invoicing/sales-orders/new'
    | '/_authenticated/settings/xero/callback'
    | '/_authenticated/silo-counts/counts/$countId'
    | '/_authenticated/stores-transfers/adjustments/$adjustmentId'
    | '/_authenticated/stores-transfers/adjustments/new'
    | '/_authenticated/stores-transfers/issues/$issueId'
    | '/_authenticated/stores-transfers/issues/new'
    | '/_authenticated/stores-transfers/transfers/$transferId'
    | '/_authenticated/stores-transfers/transfers/new'
    | '/_authenticated/production-packconv/runs/'
    | '/_authenticated/sales-invoicing/credit-notes/'
    | '/_authenticated/sales-invoicing/dispatches/'
    | '/_authenticated/sales-invoicing/invoices/'
    | '/_authenticated/sales-invoicing/sales-orders/'
    | '/_authenticated/settings/xero/'
    | '/_authenticated/silo-counts/counts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth-callback': {
      id: '/auth-callback'
      path: '/auth-callback'
      fullPath: '/auth-callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/stores-transfers': {
      id: '/_authenticated/stores-transfers'
      path: '/stores-transfers'
      fullPath: '/stores-transfers'
      preLoaderRoute: typeof AuthenticatedStoresTransfersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/silo-counts': {
      id: '/_authenticated/silo-counts'
      path: '/silo-counts'
      fullPath: '/silo-counts'
      preLoaderRoute: typeof AuthenticatedSiloCountsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/search': {
      id: '/_authenticated/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthenticatedSearchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sales-invoicing': {
      id: '/_authenticated/sales-invoicing'
      path: '/sales-invoicing'
      fullPath: '/sales-invoicing'
      preLoaderRoute: typeof AuthenticatedSalesInvoicingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/purchasing-intake': {
      id: '/_authenticated/purchasing-intake'
      path: '/purchasing-intake'
      fullPath: '/purchasing-intake'
      preLoaderRoute: typeof AuthenticatedPurchasingIntakeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/production-packconv': {
      id: '/_authenticated/production-packconv'
      path: '/production-packconv'
      fullPath: '/production-packconv'
      preLoaderRoute: typeof AuthenticatedProductionPackconvRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/help': {
      id: '/_authenticated/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof AuthenticatedHelpRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/stores-transfers/': {
      id: '/_authenticated/stores-transfers/'
      path: '/'
      fullPath: '/stores-transfers/'
      preLoaderRoute: typeof AuthenticatedStoresTransfersIndexRouteImport
      parentRoute: typeof AuthenticatedStoresTransfersRoute
    }
    '/_authenticated/silo-counts/': {
      id: '/_authenticated/silo-counts/'
      path: '/'
      fullPath: '/silo-counts/'
      preLoaderRoute: typeof AuthenticatedSiloCountsIndexRouteImport
      parentRoute: typeof AuthenticatedSiloCountsRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/sales-invoicing/': {
      id: '/_authenticated/sales-invoicing/'
      path: '/'
      fullPath: '/sales-invoicing/'
      preLoaderRoute: typeof AuthenticatedSalesInvoicingIndexRouteImport
      parentRoute: typeof AuthenticatedSalesInvoicingRoute
    }
    '/_authenticated/reports/': {
      id: '/_authenticated/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthenticatedReportsIndexRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/purchasing-intake/': {
      id: '/_authenticated/purchasing-intake/'
      path: '/'
      fullPath: '/purchasing-intake/'
      preLoaderRoute: typeof AuthenticatedPurchasingIntakeIndexRouteImport
      parentRoute: typeof AuthenticatedPurchasingIntakeRoute
    }
    '/_authenticated/products/': {
      id: '/_authenticated/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AuthenticatedProductsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/production-packconv/': {
      id: '/_authenticated/production-packconv/'
      path: '/'
      fullPath: '/production-packconv/'
      preLoaderRoute: typeof AuthenticatedProductionPackconvIndexRouteImport
      parentRoute: typeof AuthenticatedProductionPackconvRoute
    }
    '/_authenticated/silo-counts/status': {
      id: '/_authenticated/silo-counts/status'
      path: '/status'
      fullPath: '/silo-counts/status'
      preLoaderRoute: typeof AuthenticatedSiloCountsStatusRouteImport
      parentRoute: typeof AuthenticatedSiloCountsRoute
    }
    '/_authenticated/silo-counts/new-reading': {
      id: '/_authenticated/silo-counts/new-reading'
      path: '/new-reading'
      fullPath: '/silo-counts/new-reading'
      preLoaderRoute: typeof AuthenticatedSiloCountsNewReadingRouteImport
      parentRoute: typeof AuthenticatedSiloCountsRoute
    }
    '/_authenticated/silo-counts/counts': {
      id: '/_authenticated/silo-counts/counts'
      path: '/counts'
      fullPath: '/silo-counts/counts'
      preLoaderRoute: typeof AuthenticatedSiloCountsCountsRouteImport
      parentRoute: typeof AuthenticatedSiloCountsRoute
    }
    '/_authenticated/silo-counts/calibration': {
      id: '/_authenticated/silo-counts/calibration'
      path: '/calibration'
      fullPath: '/silo-counts/calibration'
      preLoaderRoute: typeof AuthenticatedSiloCountsCalibrationRouteImport
      parentRoute: typeof AuthenticatedSiloCountsRoute
    }
    '/_authenticated/settings/xero': {
      id: '/_authenticated/settings/xero'
      path: '/xero'
      fullPath: '/settings/xero'
      preLoaderRoute: typeof AuthenticatedSettingsXeroRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/users': {
      id: '/_authenticated/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AuthenticatedSettingsUsersRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/sites-locations': {
      id: '/_authenticated/settings/sites-locations'
      path: '/sites-locations'
      fullPath: '/settings/sites-locations'
      preLoaderRoute: typeof AuthenticatedSettingsSitesLocationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/products': {
      id: '/_authenticated/settings/products'
      path: '/products'
      fullPath: '/settings/products'
      preLoaderRoute: typeof AuthenticatedSettingsProductsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/importer': {
      id: '/_authenticated/settings/importer'
      path: '/importer'
      fullPath: '/settings/importer'
      preLoaderRoute: typeof AuthenticatedSettingsImporterRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/cost-centres': {
      id: '/_authenticated/settings/cost-centres'
      path: '/cost-centres'
      fullPath: '/settings/cost-centres'
      preLoaderRoute: typeof AuthenticatedSettingsCostCentresRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/sales-invoicing/sales-orders': {
      id: '/_authenticated/sales-invoicing/sales-orders'
      path: '/sales-orders'
      fullPath: '/sales-invoicing/sales-orders'
      preLoaderRoute: typeof AuthenticatedSalesInvoicingSalesOrdersRouteImport
      parentRoute: typeof AuthenticatedSalesInvoicingRoute
    }
    '/_authenticated/sales-invoicing/raise': {
      id: '/_authenticated/sales-invoicing/raise'
      path: '/raise'
      fullPath: '/sales-invoicing/raise'
      preLoaderRoute: typeof AuthenticatedSalesInvoicingRaiseRouteImport
      parentRoute: typeof AuthenticatedSalesInvoicingRoute
    }
    '/_authenticated/sales-invoicing/invoices': {
      id: '/_authenticated/sales-invoicing/invoices'
      path: '/invoices'
      fullPath: '/sales-invoicing/invoices'
      preLoaderRoute: typeof AuthenticatedSalesInvoicingInvoicesRouteImport
      parentRoute: typeof AuthenticatedSalesInvoicingRoute
    }
    '/_authenticated/sales-invoicing/dispatches': {
      id: '/_authenticated/sales-invoicing/dispatches'
      path: '/dispatches'
      fullPath: '/sales-invoicing/dispatches'
      preLoaderRoute: typeof AuthenticatedSalesInvoicingDispatchesRouteImport
      parentRoute: typeof AuthenticatedSalesInvoicingRoute
    }
    '/_authenticated/sales-invoicing/dispatch-manual': {
      id: '/_authenticated/sales-invoicing/dispatch-manual'
      path: '/dispatch-manual'
      fullPath: '/sales-invoicing/dispatch-manual'
      preLoaderRoute: typeof AuthenticatedSalesInvoicingDispatchManualRouteImport
      parentRoute: typeof AuthenticatedSalesInvoicingRoute
    }
    '/_authenticated/sales-invoicing/customers': {
      id: '/_authenticated/sales-invoicing/customers'
      path: '/customers'
      fullPath: '/sales-invoicing/customers'
      preLoaderRoute: typeof AuthenticatedSalesInvoicingCustomersRouteImport
      parentRoute: typeof AuthenticatedSalesInvoicingRoute
    }
    '/_authenticated/sales-invoicing/credit-notes': {
      id: '/_authenticated/sales-invoicing/credit-notes'
      path: '/credit-notes'
      fullPath: '/sales-invoicing/credit-notes'
      preLoaderRoute: typeof AuthenticatedSalesInvoicingCreditNotesRouteImport
      parentRoute: typeof AuthenticatedSalesInvoicingRoute
    }
    '/_authenticated/reports/yield': {
      id: '/_authenticated/reports/yield'
      path: '/yield'
      fullPath: '/reports/yield'
      preLoaderRoute: typeof AuthenticatedReportsYieldRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/uninvoiced-dispatches': {
      id: '/_authenticated/reports/uninvoiced-dispatches'
      path: '/uninvoiced-dispatches'
      fullPath: '/reports/uninvoiced-dispatches'
      preLoaderRoute: typeof AuthenticatedReportsUninvoicedDispatchesRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/stock-on-hand': {
      id: '/_authenticated/reports/stock-on-hand'
      path: '/stock-on-hand'
      fullPath: '/reports/stock-on-hand'
      preLoaderRoute: typeof AuthenticatedReportsStockOnHandRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/silo-drift': {
      id: '/_authenticated/reports/silo-drift'
      path: '/silo-drift'
      fullPath: '/reports/silo-drift'
      preLoaderRoute: typeof AuthenticatedReportsSiloDriftRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/sales': {
      id: '/_authenticated/reports/sales'
      path: '/sales'
      fullPath: '/reports/sales'
      preLoaderRoute: typeof AuthenticatedReportsSalesRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/reorder': {
      id: '/_authenticated/reports/reorder'
      path: '/reorder'
      fullPath: '/reports/reorder'
      preLoaderRoute: typeof AuthenticatedReportsReorderRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/purchasing': {
      id: '/_authenticated/reports/purchasing'
      path: '/purchasing'
      fullPath: '/reports/purchasing'
      preLoaderRoute: typeof AuthenticatedReportsPurchasingRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/products': {
      id: '/_authenticated/reports/products'
      path: '/products'
      fullPath: '/reports/products'
      preLoaderRoute: typeof AuthenticatedReportsProductsRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/movements': {
      id: '/_authenticated/reports/movements'
      path: '/movements'
      fullPath: '/reports/movements'
      preLoaderRoute: typeof AuthenticatedReportsMovementsRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/mass-balance': {
      id: '/_authenticated/reports/mass-balance'
      path: '/mass-balance'
      fullPath: '/reports/mass-balance'
      preLoaderRoute: typeof AuthenticatedReportsMassBalanceRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/margin': {
      id: '/_authenticated/reports/margin'
      path: '/margin'
      fullPath: '/reports/margin'
      preLoaderRoute: typeof AuthenticatedReportsMarginRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/genealogy': {
      id: '/_authenticated/reports/genealogy'
      path: '/genealogy'
      fullPath: '/reports/genealogy'
      preLoaderRoute: typeof AuthenticatedReportsGenealogyRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/consumable-spend': {
      id: '/_authenticated/reports/consumable-spend'
      path: '/consumable-spend'
      fullPath: '/reports/consumable-spend'
      preLoaderRoute: typeof AuthenticatedReportsConsumableSpendRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/purchasing-intake/suppliers': {
      id: '/_authenticated/purchasing-intake/suppliers'
      path: '/suppliers'
      fullPath: '/purchasing-intake/suppliers'
      preLoaderRoute: typeof AuthenticatedPurchasingIntakeSuppliersRouteImport
      parentRoute: typeof AuthenticatedPurchasingIntakeRoute
    }
    '/_authenticated/purchasing-intake/reorder': {
      id: '/_authenticated/purchasing-intake/reorder'
      path: '/reorder'
      fullPath: '/purchasing-intake/reorder'
      preLoaderRoute: typeof AuthenticatedPurchasingIntakeReorderRouteImport
      parentRoute: typeof AuthenticatedPurchasingIntakeRoute
    }
    '/_authenticated/purchasing-intake/receive-manual': {
      id: '/_authenticated/purchasing-intake/receive-manual'
      path: '/receive-manual'
      fullPath: '/purchasing-intake/receive-manual'
      preLoaderRoute: typeof AuthenticatedPurchasingIntakeReceiveManualRouteImport
      parentRoute: typeof AuthenticatedPurchasingIntakeRoute
    }
    '/_authenticated/purchasing-intake/receipts': {
      id: '/_authenticated/purchasing-intake/receipts'
      path: '/receipts'
      fullPath: '/purchasing-intake/receipts'
      preLoaderRoute: typeof AuthenticatedPurchasingIntakeReceiptsRouteImport
      parentRoute: typeof AuthenticatedPurchasingIntakeRoute
    }
    '/_authenticated/purchasing-intake/purchase-orders': {
      id: '/_authenticated/purchasing-intake/purchase-orders'
      path: '/purchase-orders'
      fullPath: '/purchasing-intake/purchase-orders'
      preLoaderRoute: typeof AuthenticatedPurchasingIntakePurchaseOrdersRouteImport
      parentRoute: typeof AuthenticatedPurchasingIntakeRoute
    }
    '/_authenticated/purchasing-intake/landed-cost': {
      id: '/_authenticated/purchasing-intake/landed-cost'
      path: '/landed-cost'
      fullPath: '/purchasing-intake/landed-cost'
      preLoaderRoute: typeof AuthenticatedPurchasingIntakeLandedCostRouteImport
      parentRoute: typeof AuthenticatedPurchasingIntakeRoute
    }
    '/_authenticated/purchasing-intake/contracts': {
      id: '/_authenticated/purchasing-intake/contracts'
      path: '/contracts'
      fullPath: '/purchasing-intake/contracts'
      preLoaderRoute: typeof AuthenticatedPurchasingIntakeContractsRouteImport
      parentRoute: typeof AuthenticatedPurchasingIntakeRoute
    }
    '/_authenticated/products/$productId': {
      id: '/_authenticated/products/$productId'
      path: '/products/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof AuthenticatedProductsProductIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/production-packconv/stages': {
      id: '/_authenticated/production-packconv/stages'
      path: '/stages'
      fullPath: '/production-packconv/stages'
      preLoaderRoute: typeof AuthenticatedProductionPackconvStagesRouteImport
      parentRoute: typeof AuthenticatedProductionPackconvRoute
    }
    '/_authenticated/production-packconv/runs': {
      id: '/_authenticated/production-packconv/runs'
      path: '/runs'
      fullPath: '/production-packconv/runs'
      preLoaderRoute: typeof AuthenticatedProductionPackconvRunsRouteImport
      parentRoute: typeof AuthenticatedProductionPackconvRoute
    }
    '/_authenticated/production-packconv/quick': {
      id: '/_authenticated/production-packconv/quick'
      path: '/quick'
      fullPath: '/production-packconv/quick'
      preLoaderRoute: typeof AuthenticatedProductionPackconvQuickRouteImport
      parentRoute: typeof AuthenticatedProductionPackconvRoute
    }
    '/_authenticated/production-packconv/pack-conversion': {
      id: '/_authenticated/production-packconv/pack-conversion'
      path: '/pack-conversion'
      fullPath: '/production-packconv/pack-conversion'
      preLoaderRoute: typeof AuthenticatedProductionPackconvPackConversionRouteImport
      parentRoute: typeof AuthenticatedProductionPackconvRoute
    }
    '/_authenticated/production-packconv/batches': {
      id: '/_authenticated/production-packconv/batches'
      path: '/batches'
      fullPath: '/production-packconv/batches'
      preLoaderRoute: typeof AuthenticatedProductionPackconvBatchesRouteImport
      parentRoute: typeof AuthenticatedProductionPackconvRoute
    }
    '/_authenticated/silo-counts/counts/': {
      id: '/_authenticated/silo-counts/counts/'
      path: '/'
      fullPath: '/silo-counts/counts/'
      preLoaderRoute: typeof AuthenticatedSiloCountsCountsIndexRouteImport
      parentRoute: typeof AuthenticatedSiloCountsCountsRoute
    }
    '/_authenticated/settings/xero/': {
      id: '/_authenticated/settings/xero/'
      path: '/'
      fullPath: '/settings/xero/'
      preLoaderRoute: typeof AuthenticatedSettingsXeroIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsXeroRoute
    }
    '/_authenticated/sales-invoicing/sales-orders/': {
      id: '/_authenticated/sales-invoicing/sales-orders/'
      path: '/'
      fullPath: '/sales-invoicing/sales-orders/'
      preLoaderRoute: typeof AuthenticatedSalesInvoicingSalesOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedSalesInvoicingSalesOrdersRoute
    }
    '/_authenticated/sales-invoicing/invoices/': {
      id: '/_authenticated/sales-invoicing/invoices/'
      path: '/'
      fullPath: '/sales-invoicing/invoices/'
      preLoaderRoute: typeof AuthenticatedSalesInvoicingInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedSalesInvoicingInvoicesRoute
    }
    '/_authenticated/sales-invoicing/dispatches/': {
      id: '/_authenticated/sales-invoicing/dispatches/'
      path: '/'
      fullPath: '/sales-invoicing/dispatches/'
      preLoaderRoute: typeof AuthenticatedSalesInvoicingDispatchesIndexRouteImport
      parentRoute: typeof AuthenticatedSalesInvoicingDispatchesRoute
    }
    '/_authenticated/sales-invoicing/credit-notes/': {
      id: '/_authenticated/sales-invoicing/credit-notes/'
      path: '/'
      fullPath: '/sales-invoicing/credit-notes/'
      preLoaderRoute: typeof AuthenticatedSalesInvoicingCreditNotesIndexRouteImport
      parentRoute: typeof AuthenticatedSalesInvoicingCreditNotesRoute
    }
    '/_authenticated/production-packconv/runs/': {
      id: '/_authenticated/production-packconv/runs/'
      path: '/'
      fullPath: '/production-packconv/runs/'
      preLoaderRoute: typeof AuthenticatedProductionPackconvRunsIndexRouteImport
      parentRoute: typeof AuthenticatedProductionPackconvRunsRoute
    }
    '/_authenticated/stores-transfers/transfers/new': {
      id: '/_authenticated/stores-transfers/transfers/new'
      path: '/transfers/new'
      fullPath: '/stores-transfers/transfers/new'
      preLoaderRoute: typeof AuthenticatedStoresTransfersTransfersNewRouteImport
      parentRoute: typeof AuthenticatedStoresTransfersRoute
    }
    '/_authenticated/stores-transfers/transfers/$transferId': {
      id: '/_authenticated/stores-transfers/transfers/$transferId'
      path: '/transfers/$transferId'
      fullPath: '/stores-transfers/transfers/$transferId'
      preLoaderRoute: typeof AuthenticatedStoresTransfersTransfersTransferIdRouteImport
      parentRoute: typeof AuthenticatedStoresTransfersRoute
    }
    '/_authenticated/stores-transfers/issues/new': {
      id: '/_authenticated/stores-transfers/issues/new'
      path: '/issues/new'
      fullPath: '/stores-transfers/issues/new'
      preLoaderRoute: typeof AuthenticatedStoresTransfersIssuesNewRouteImport
      parentRoute: typeof AuthenticatedStoresTransfersRoute
    }
    '/_authenticated/stores-transfers/issues/$issueId': {
      id: '/_authenticated/stores-transfers/issues/$issueId'
      path: '/issues/$issueId'
      fullPath: '/stores-transfers/issues/$issueId'
      preLoaderRoute: typeof AuthenticatedStoresTransfersIssuesIssueIdRouteImport
      parentRoute: typeof AuthenticatedStoresTransfersRoute
    }
    '/_authenticated/stores-transfers/adjustments/new': {
      id: '/_authenticated/stores-transfers/adjustments/new'
      path: '/adjustments/new'
      fullPath: '/stores-transfers/adjustments/new'
      preLoaderRoute: typeof AuthenticatedStoresTransfersAdjustmentsNewRouteImport
      parentRoute: typeof AuthenticatedStoresTransfersRoute
    }
    '/_authenticated/stores-transfers/adjustments/$adjustmentId': {
      id: '/_authenticated/stores-transfers/adjustments/$adjustmentId'
      path: '/adjustments/$adjustmentId'
      fullPath: '/stores-transfers/adjustments/$adjustmentId'
      preLoaderRoute: typeof AuthenticatedStoresTransfersAdjustmentsAdjustmentIdRouteImport
      parentRoute: typeof AuthenticatedStoresTransfersRoute
    }
    '/_authenticated/silo-counts/counts/$countId': {
      id: '/_authenticated/silo-counts/counts/$countId'
      path: '/$countId'
      fullPath: '/silo-counts/counts/$countId'
      preLoaderRoute: typeof AuthenticatedSiloCountsCountsCountIdRouteImport
      parentRoute: typeof AuthenticatedSiloCountsCountsRoute
    }
    '/_authenticated/settings/xero/callback': {
      id: '/_authenticated/settings/xero/callback'
      path: '/callback'
      fullPath: '/settings/xero/callback'
      preLoaderRoute: typeof AuthenticatedSettingsXeroCallbackRouteImport
      parentRoute: typeof AuthenticatedSettingsXeroRoute
    }
    '/_authenticated/sales-invoicing/sales-orders/new': {
      id: '/_authenticated/sales-invoicing/sales-orders/new'
      path: '/new'
      fullPath: '/sales-invoicing/sales-orders/new'
      preLoaderRoute: typeof AuthenticatedSalesInvoicingSalesOrdersNewRouteImport
      parentRoute: typeof AuthenticatedSalesInvoicingSalesOrdersRoute
    }
    '/_authenticated/sales-invoicing/sales-orders/$salesOrderId': {
      id: '/_authenticated/sales-invoicing/sales-orders/$salesOrderId'
      path: '/$salesOrderId'
      fullPath: '/sales-invoicing/sales-orders/$salesOrderId'
      preLoaderRoute: typeof AuthenticatedSalesInvoicingSalesOrdersSalesOrderIdRouteImport
      parentRoute: typeof AuthenticatedSalesInvoicingSalesOrdersRoute
    }
    '/_authenticated/sales-invoicing/invoices/$invoiceId': {
      id: '/_authenticated/sales-invoicing/invoices/$invoiceId'
      path: '/$invoiceId'
      fullPath: '/sales-invoicing/invoices/$invoiceId'
      preLoaderRoute: typeof AuthenticatedSalesInvoicingInvoicesInvoiceIdRouteImport
      parentRoute: typeof AuthenticatedSalesInvoicingInvoicesRoute
    }
    '/_authenticated/sales-invoicing/dispatches/$dispatchId': {
      id: '/_authenticated/sales-invoicing/dispatches/$dispatchId'
      path: '/$dispatchId'
      fullPath: '/sales-invoicing/dispatches/$dispatchId'
      preLoaderRoute: typeof AuthenticatedSalesInvoicingDispatchesDispatchIdRouteImport
      parentRoute: typeof AuthenticatedSalesInvoicingDispatchesRoute
    }
    '/_authenticated/sales-invoicing/credit-notes/new': {
      id: '/_authenticated/sales-invoicing/credit-notes/new'
      path: '/new'
      fullPath: '/sales-invoicing/credit-notes/new'
      preLoaderRoute: typeof AuthenticatedSalesInvoicingCreditNotesNewRouteImport
      parentRoute: typeof AuthenticatedSalesInvoicingCreditNotesRoute
    }
    '/_authenticated/sales-invoicing/credit-notes/$creditNoteId': {
      id: '/_authenticated/sales-invoicing/credit-notes/$creditNoteId'
      path: '/$creditNoteId'
      fullPath: '/sales-invoicing/credit-notes/$creditNoteId'
      preLoaderRoute: typeof AuthenticatedSalesInvoicingCreditNotesCreditNoteIdRouteImport
      parentRoute: typeof AuthenticatedSalesInvoicingCreditNotesRoute
    }
    '/_authenticated/production-packconv/runs/$runId': {
      id: '/_authenticated/production-packconv/runs/$runId'
      path: '/$runId'
      fullPath: '/production-packconv/runs/$runId'
      preLoaderRoute: typeof AuthenticatedProductionPackconvRunsRunIdRouteImport
      parentRoute: typeof AuthenticatedProductionPackconvRunsRoute
    }
  }
}

interface AuthenticatedProductionPackconvRunsRouteChildren {
  AuthenticatedProductionPackconvRunsRunIdRoute: typeof AuthenticatedProductionPackconvRunsRunIdRoute
  AuthenticatedProductionPackconvRunsIndexRoute: typeof AuthenticatedProductionPackconvRunsIndexRoute
}

const AuthenticatedProductionPackconvRunsRouteChildren: AuthenticatedProductionPackconvRunsRouteChildren =
  {
    AuthenticatedProductionPackconvRunsRunIdRoute:
      AuthenticatedProductionPackconvRunsRunIdRoute,
    AuthenticatedProductionPackconvRunsIndexRoute:
      AuthenticatedProductionPackconvRunsIndexRoute,
  }

const AuthenticatedProductionPackconvRunsRouteWithChildren =
  AuthenticatedProductionPackconvRunsRoute._addFileChildren(
    AuthenticatedProductionPackconvRunsRouteChildren,
  )

interface AuthenticatedProductionPackconvRouteChildren {
  AuthenticatedProductionPackconvBatchesRoute: typeof AuthenticatedProductionPackconvBatchesRoute
  AuthenticatedProductionPackconvPackConversionRoute: typeof AuthenticatedProductionPackconvPackConversionRoute
  AuthenticatedProductionPackconvQuickRoute: typeof AuthenticatedProductionPackconvQuickRoute
  AuthenticatedProductionPackconvRunsRoute: typeof AuthenticatedProductionPackconvRunsRouteWithChildren
  AuthenticatedProductionPackconvStagesRoute: typeof AuthenticatedProductionPackconvStagesRoute
  AuthenticatedProductionPackconvIndexRoute: typeof AuthenticatedProductionPackconvIndexRoute
}

const AuthenticatedProductionPackconvRouteChildren: AuthenticatedProductionPackconvRouteChildren =
  {
    AuthenticatedProductionPackconvBatchesRoute:
      AuthenticatedProductionPackconvBatchesRoute,
    AuthenticatedProductionPackconvPackConversionRoute:
      AuthenticatedProductionPackconvPackConversionRoute,
    AuthenticatedProductionPackconvQuickRoute:
      AuthenticatedProductionPackconvQuickRoute,
    AuthenticatedProductionPackconvRunsRoute:
      AuthenticatedProductionPackconvRunsRouteWithChildren,
    AuthenticatedProductionPackconvStagesRoute:
      AuthenticatedProductionPackconvStagesRoute,
    AuthenticatedProductionPackconvIndexRoute:
      AuthenticatedProductionPackconvIndexRoute,
  }

const AuthenticatedProductionPackconvRouteWithChildren =
  AuthenticatedProductionPackconvRoute._addFileChildren(
    AuthenticatedProductionPackconvRouteChildren,
  )

interface AuthenticatedPurchasingIntakeRouteChildren {
  AuthenticatedPurchasingIntakeContractsRoute: typeof AuthenticatedPurchasingIntakeContractsRoute
  AuthenticatedPurchasingIntakeLandedCostRoute: typeof AuthenticatedPurchasingIntakeLandedCostRoute
  AuthenticatedPurchasingIntakePurchaseOrdersRoute: typeof AuthenticatedPurchasingIntakePurchaseOrdersRoute
  AuthenticatedPurchasingIntakeReceiptsRoute: typeof AuthenticatedPurchasingIntakeReceiptsRoute
  AuthenticatedPurchasingIntakeReceiveManualRoute: typeof AuthenticatedPurchasingIntakeReceiveManualRoute
  AuthenticatedPurchasingIntakeReorderRoute: typeof AuthenticatedPurchasingIntakeReorderRoute
  AuthenticatedPurchasingIntakeSuppliersRoute: typeof AuthenticatedPurchasingIntakeSuppliersRoute
  AuthenticatedPurchasingIntakeIndexRoute: typeof AuthenticatedPurchasingIntakeIndexRoute
}

const AuthenticatedPurchasingIntakeRouteChildren: AuthenticatedPurchasingIntakeRouteChildren =
  {
    AuthenticatedPurchasingIntakeContractsRoute:
      AuthenticatedPurchasingIntakeContractsRoute,
    AuthenticatedPurchasingIntakeLandedCostRoute:
      AuthenticatedPurchasingIntakeLandedCostRoute,
    AuthenticatedPurchasingIntakePurchaseOrdersRoute:
      AuthenticatedPurchasingIntakePurchaseOrdersRoute,
    AuthenticatedPurchasingIntakeReceiptsRoute:
      AuthenticatedPurchasingIntakeReceiptsRoute,
    AuthenticatedPurchasingIntakeReceiveManualRoute:
      AuthenticatedPurchasingIntakeReceiveManualRoute,
    AuthenticatedPurchasingIntakeReorderRoute:
      AuthenticatedPurchasingIntakeReorderRoute,
    AuthenticatedPurchasingIntakeSuppliersRoute:
      AuthenticatedPurchasingIntakeSuppliersRoute,
    AuthenticatedPurchasingIntakeIndexRoute:
      AuthenticatedPurchasingIntakeIndexRoute,
  }

const AuthenticatedPurchasingIntakeRouteWithChildren =
  AuthenticatedPurchasingIntakeRoute._addFileChildren(
    AuthenticatedPurchasingIntakeRouteChildren,
  )

interface AuthenticatedReportsRouteChildren {
  AuthenticatedReportsConsumableSpendRoute: typeof AuthenticatedReportsConsumableSpendRoute
  AuthenticatedReportsGenealogyRoute: typeof AuthenticatedReportsGenealogyRoute
  AuthenticatedReportsMarginRoute: typeof AuthenticatedReportsMarginRoute
  AuthenticatedReportsMassBalanceRoute: typeof AuthenticatedReportsMassBalanceRoute
  AuthenticatedReportsMovementsRoute: typeof AuthenticatedReportsMovementsRoute
  AuthenticatedReportsProductsRoute: typeof AuthenticatedReportsProductsRoute
  AuthenticatedReportsPurchasingRoute: typeof AuthenticatedReportsPurchasingRoute
  AuthenticatedReportsReorderRoute: typeof AuthenticatedReportsReorderRoute
  AuthenticatedReportsSalesRoute: typeof AuthenticatedReportsSalesRoute
  AuthenticatedReportsSiloDriftRoute: typeof AuthenticatedReportsSiloDriftRoute
  AuthenticatedReportsStockOnHandRoute: typeof AuthenticatedReportsStockOnHandRoute
  AuthenticatedReportsUninvoicedDispatchesRoute: typeof AuthenticatedReportsUninvoicedDispatchesRoute
  AuthenticatedReportsYieldRoute: typeof AuthenticatedReportsYieldRoute
  AuthenticatedReportsIndexRoute: typeof AuthenticatedReportsIndexRoute
}

const AuthenticatedReportsRouteChildren: AuthenticatedReportsRouteChildren = {
  AuthenticatedReportsConsumableSpendRoute:
    AuthenticatedReportsConsumableSpendRoute,
  AuthenticatedReportsGenealogyRoute: AuthenticatedReportsGenealogyRoute,
  AuthenticatedReportsMarginRoute: AuthenticatedReportsMarginRoute,
  AuthenticatedReportsMassBalanceRoute: AuthenticatedReportsMassBalanceRoute,
  AuthenticatedReportsMovementsRoute: AuthenticatedReportsMovementsRoute,
  AuthenticatedReportsProductsRoute: AuthenticatedReportsProductsRoute,
  AuthenticatedReportsPurchasingRoute: AuthenticatedReportsPurchasingRoute,
  AuthenticatedReportsReorderRoute: AuthenticatedReportsReorderRoute,
  AuthenticatedReportsSalesRoute: AuthenticatedReportsSalesRoute,
  AuthenticatedReportsSiloDriftRoute: AuthenticatedReportsSiloDriftRoute,
  AuthenticatedReportsStockOnHandRoute: AuthenticatedReportsStockOnHandRoute,
  AuthenticatedReportsUninvoicedDispatchesRoute:
    AuthenticatedReportsUninvoicedDispatchesRoute,
  AuthenticatedReportsYieldRoute: AuthenticatedReportsYieldRoute,
  AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute,
}

const AuthenticatedReportsRouteWithChildren =
  AuthenticatedReportsRoute._addFileChildren(AuthenticatedReportsRouteChildren)

interface AuthenticatedSalesInvoicingCreditNotesRouteChildren {
  AuthenticatedSalesInvoicingCreditNotesCreditNoteIdRoute: typeof AuthenticatedSalesInvoicingCreditNotesCreditNoteIdRoute
  AuthenticatedSalesInvoicingCreditNotesNewRoute: typeof AuthenticatedSalesInvoicingCreditNotesNewRoute
  AuthenticatedSalesInvoicingCreditNotesIndexRoute: typeof AuthenticatedSalesInvoicingCreditNotesIndexRoute
}

const AuthenticatedSalesInvoicingCreditNotesRouteChildren: AuthenticatedSalesInvoicingCreditNotesRouteChildren =
  {
    AuthenticatedSalesInvoicingCreditNotesCreditNoteIdRoute:
      AuthenticatedSalesInvoicingCreditNotesCreditNoteIdRoute,
    AuthenticatedSalesInvoicingCreditNotesNewRoute:
      AuthenticatedSalesInvoicingCreditNotesNewRoute,
    AuthenticatedSalesInvoicingCreditNotesIndexRoute:
      AuthenticatedSalesInvoicingCreditNotesIndexRoute,
  }

const AuthenticatedSalesInvoicingCreditNotesRouteWithChildren =
  AuthenticatedSalesInvoicingCreditNotesRoute._addFileChildren(
    AuthenticatedSalesInvoicingCreditNotesRouteChildren,
  )

interface AuthenticatedSalesInvoicingDispatchesRouteChildren {
  AuthenticatedSalesInvoicingDispatchesDispatchIdRoute: typeof AuthenticatedSalesInvoicingDispatchesDispatchIdRoute
  AuthenticatedSalesInvoicingDispatchesIndexRoute: typeof AuthenticatedSalesInvoicingDispatchesIndexRoute
}

const AuthenticatedSalesInvoicingDispatchesRouteChildren: AuthenticatedSalesInvoicingDispatchesRouteChildren =
  {
    AuthenticatedSalesInvoicingDispatchesDispatchIdRoute:
      AuthenticatedSalesInvoicingDispatchesDispatchIdRoute,
    AuthenticatedSalesInvoicingDispatchesIndexRoute:
      AuthenticatedSalesInvoicingDispatchesIndexRoute,
  }

const AuthenticatedSalesInvoicingDispatchesRouteWithChildren =
  AuthenticatedSalesInvoicingDispatchesRoute._addFileChildren(
    AuthenticatedSalesInvoicingDispatchesRouteChildren,
  )

interface AuthenticatedSalesInvoicingInvoicesRouteChildren {
  AuthenticatedSalesInvoicingInvoicesInvoiceIdRoute: typeof AuthenticatedSalesInvoicingInvoicesInvoiceIdRoute
  AuthenticatedSalesInvoicingInvoicesIndexRoute: typeof AuthenticatedSalesInvoicingInvoicesIndexRoute
}

const AuthenticatedSalesInvoicingInvoicesRouteChildren: AuthenticatedSalesInvoicingInvoicesRouteChildren =
  {
    AuthenticatedSalesInvoicingInvoicesInvoiceIdRoute:
      AuthenticatedSalesInvoicingInvoicesInvoiceIdRoute,
    AuthenticatedSalesInvoicingInvoicesIndexRoute:
      AuthenticatedSalesInvoicingInvoicesIndexRoute,
  }

const AuthenticatedSalesInvoicingInvoicesRouteWithChildren =
  AuthenticatedSalesInvoicingInvoicesRoute._addFileChildren(
    AuthenticatedSalesInvoicingInvoicesRouteChildren,
  )

interface AuthenticatedSalesInvoicingSalesOrdersRouteChildren {
  AuthenticatedSalesInvoicingSalesOrdersSalesOrderIdRoute: typeof AuthenticatedSalesInvoicingSalesOrdersSalesOrderIdRoute
  AuthenticatedSalesInvoicingSalesOrdersNewRoute: typeof AuthenticatedSalesInvoicingSalesOrdersNewRoute
  AuthenticatedSalesInvoicingSalesOrdersIndexRoute: typeof AuthenticatedSalesInvoicingSalesOrdersIndexRoute
}

const AuthenticatedSalesInvoicingSalesOrdersRouteChildren: AuthenticatedSalesInvoicingSalesOrdersRouteChildren =
  {
    AuthenticatedSalesInvoicingSalesOrdersSalesOrderIdRoute:
      AuthenticatedSalesInvoicingSalesOrdersSalesOrderIdRoute,
    AuthenticatedSalesInvoicingSalesOrdersNewRoute:
      AuthenticatedSalesInvoicingSalesOrdersNewRoute,
    AuthenticatedSalesInvoicingSalesOrdersIndexRoute:
      AuthenticatedSalesInvoicingSalesOrdersIndexRoute,
  }

const AuthenticatedSalesInvoicingSalesOrdersRouteWithChildren =
  AuthenticatedSalesInvoicingSalesOrdersRoute._addFileChildren(
    AuthenticatedSalesInvoicingSalesOrdersRouteChildren,
  )

interface AuthenticatedSalesInvoicingRouteChildren {
  AuthenticatedSalesInvoicingCreditNotesRoute: typeof AuthenticatedSalesInvoicingCreditNotesRouteWithChildren
  AuthenticatedSalesInvoicingCustomersRoute: typeof AuthenticatedSalesInvoicingCustomersRoute
  AuthenticatedSalesInvoicingDispatchManualRoute: typeof AuthenticatedSalesInvoicingDispatchManualRoute
  AuthenticatedSalesInvoicingDispatchesRoute: typeof AuthenticatedSalesInvoicingDispatchesRouteWithChildren
  AuthenticatedSalesInvoicingInvoicesRoute: typeof AuthenticatedSalesInvoicingInvoicesRouteWithChildren
  AuthenticatedSalesInvoicingRaiseRoute: typeof AuthenticatedSalesInvoicingRaiseRoute
  AuthenticatedSalesInvoicingSalesOrdersRoute: typeof AuthenticatedSalesInvoicingSalesOrdersRouteWithChildren
  AuthenticatedSalesInvoicingIndexRoute: typeof AuthenticatedSalesInvoicingIndexRoute
}

const AuthenticatedSalesInvoicingRouteChildren: AuthenticatedSalesInvoicingRouteChildren =
  {
    AuthenticatedSalesInvoicingCreditNotesRoute:
      AuthenticatedSalesInvoicingCreditNotesRouteWithChildren,
    AuthenticatedSalesInvoicingCustomersRoute:
      AuthenticatedSalesInvoicingCustomersRoute,
    AuthenticatedSalesInvoicingDispatchManualRoute:
      AuthenticatedSalesInvoicingDispatchManualRoute,
    AuthenticatedSalesInvoicingDispatchesRoute:
      AuthenticatedSalesInvoicingDispatchesRouteWithChildren,
    AuthenticatedSalesInvoicingInvoicesRoute:
      AuthenticatedSalesInvoicingInvoicesRouteWithChildren,
    AuthenticatedSalesInvoicingRaiseRoute:
      AuthenticatedSalesInvoicingRaiseRoute,
    AuthenticatedSalesInvoicingSalesOrdersRoute:
      AuthenticatedSalesInvoicingSalesOrdersRouteWithChildren,
    AuthenticatedSalesInvoicingIndexRoute:
      AuthenticatedSalesInvoicingIndexRoute,
  }

const AuthenticatedSalesInvoicingRouteWithChildren =
  AuthenticatedSalesInvoicingRoute._addFileChildren(
    AuthenticatedSalesInvoicingRouteChildren,
  )

interface AuthenticatedSettingsXeroRouteChildren {
  AuthenticatedSettingsXeroCallbackRoute: typeof AuthenticatedSettingsXeroCallbackRoute
  AuthenticatedSettingsXeroIndexRoute: typeof AuthenticatedSettingsXeroIndexRoute
}

const AuthenticatedSettingsXeroRouteChildren: AuthenticatedSettingsXeroRouteChildren =
  {
    AuthenticatedSettingsXeroCallbackRoute:
      AuthenticatedSettingsXeroCallbackRoute,
    AuthenticatedSettingsXeroIndexRoute: AuthenticatedSettingsXeroIndexRoute,
  }

const AuthenticatedSettingsXeroRouteWithChildren =
  AuthenticatedSettingsXeroRoute._addFileChildren(
    AuthenticatedSettingsXeroRouteChildren,
  )

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsCostCentresRoute: typeof AuthenticatedSettingsCostCentresRoute
  AuthenticatedSettingsImporterRoute: typeof AuthenticatedSettingsImporterRoute
  AuthenticatedSettingsProductsRoute: typeof AuthenticatedSettingsProductsRoute
  AuthenticatedSettingsSitesLocationsRoute: typeof AuthenticatedSettingsSitesLocationsRoute
  AuthenticatedSettingsUsersRoute: typeof AuthenticatedSettingsUsersRoute
  AuthenticatedSettingsXeroRoute: typeof AuthenticatedSettingsXeroRouteWithChildren
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsCostCentresRoute: AuthenticatedSettingsCostCentresRoute,
  AuthenticatedSettingsImporterRoute: AuthenticatedSettingsImporterRoute,
  AuthenticatedSettingsProductsRoute: AuthenticatedSettingsProductsRoute,
  AuthenticatedSettingsSitesLocationsRoute:
    AuthenticatedSettingsSitesLocationsRoute,
  AuthenticatedSettingsUsersRoute: AuthenticatedSettingsUsersRoute,
  AuthenticatedSettingsXeroRoute: AuthenticatedSettingsXeroRouteWithChildren,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedSiloCountsCountsRouteChildren {
  AuthenticatedSiloCountsCountsCountIdRoute: typeof AuthenticatedSiloCountsCountsCountIdRoute
  AuthenticatedSiloCountsCountsIndexRoute: typeof AuthenticatedSiloCountsCountsIndexRoute
}

const AuthenticatedSiloCountsCountsRouteChildren: AuthenticatedSiloCountsCountsRouteChildren =
  {
    AuthenticatedSiloCountsCountsCountIdRoute:
      AuthenticatedSiloCountsCountsCountIdRoute,
    AuthenticatedSiloCountsCountsIndexRoute:
      AuthenticatedSiloCountsCountsIndexRoute,
  }

const AuthenticatedSiloCountsCountsRouteWithChildren =
  AuthenticatedSiloCountsCountsRoute._addFileChildren(
    AuthenticatedSiloCountsCountsRouteChildren,
  )

interface AuthenticatedSiloCountsRouteChildren {
  AuthenticatedSiloCountsCalibrationRoute: typeof AuthenticatedSiloCountsCalibrationRoute
  AuthenticatedSiloCountsCountsRoute: typeof AuthenticatedSiloCountsCountsRouteWithChildren
  AuthenticatedSiloCountsNewReadingRoute: typeof AuthenticatedSiloCountsNewReadingRoute
  AuthenticatedSiloCountsStatusRoute: typeof AuthenticatedSiloCountsStatusRoute
  AuthenticatedSiloCountsIndexRoute: typeof AuthenticatedSiloCountsIndexRoute
}

const AuthenticatedSiloCountsRouteChildren: AuthenticatedSiloCountsRouteChildren =
  {
    AuthenticatedSiloCountsCalibrationRoute:
      AuthenticatedSiloCountsCalibrationRoute,
    AuthenticatedSiloCountsCountsRoute:
      AuthenticatedSiloCountsCountsRouteWithChildren,
    AuthenticatedSiloCountsNewReadingRoute:
      AuthenticatedSiloCountsNewReadingRoute,
    AuthenticatedSiloCountsStatusRoute: AuthenticatedSiloCountsStatusRoute,
    AuthenticatedSiloCountsIndexRoute: AuthenticatedSiloCountsIndexRoute,
  }

const AuthenticatedSiloCountsRouteWithChildren =
  AuthenticatedSiloCountsRoute._addFileChildren(
    AuthenticatedSiloCountsRouteChildren,
  )

interface AuthenticatedStoresTransfersRouteChildren {
  AuthenticatedStoresTransfersIndexRoute: typeof AuthenticatedStoresTransfersIndexRoute
  AuthenticatedStoresTransfersAdjustmentsAdjustmentIdRoute: typeof AuthenticatedStoresTransfersAdjustmentsAdjustmentIdRoute
  AuthenticatedStoresTransfersAdjustmentsNewRoute: typeof AuthenticatedStoresTransfersAdjustmentsNewRoute
  AuthenticatedStoresTransfersIssuesIssueIdRoute: typeof AuthenticatedStoresTransfersIssuesIssueIdRoute
  AuthenticatedStoresTransfersIssuesNewRoute: typeof AuthenticatedStoresTransfersIssuesNewRoute
  AuthenticatedStoresTransfersTransfersTransferIdRoute: typeof AuthenticatedStoresTransfersTransfersTransferIdRoute
  AuthenticatedStoresTransfersTransfersNewRoute: typeof AuthenticatedStoresTransfersTransfersNewRoute
}

const AuthenticatedStoresTransfersRouteChildren: AuthenticatedStoresTransfersRouteChildren =
  {
    AuthenticatedStoresTransfersIndexRoute:
      AuthenticatedStoresTransfersIndexRoute,
    AuthenticatedStoresTransfersAdjustmentsAdjustmentIdRoute:
      AuthenticatedStoresTransfersAdjustmentsAdjustmentIdRoute,
    AuthenticatedStoresTransfersAdjustmentsNewRoute:
      AuthenticatedStoresTransfersAdjustmentsNewRoute,
    AuthenticatedStoresTransfersIssuesIssueIdRoute:
      AuthenticatedStoresTransfersIssuesIssueIdRoute,
    AuthenticatedStoresTransfersIssuesNewRoute:
      AuthenticatedStoresTransfersIssuesNewRoute,
    AuthenticatedStoresTransfersTransfersTransferIdRoute:
      AuthenticatedStoresTransfersTransfersTransferIdRoute,
    AuthenticatedStoresTransfersTransfersNewRoute:
      AuthenticatedStoresTransfersTransfersNewRoute,
  }

const AuthenticatedStoresTransfersRouteWithChildren =
  AuthenticatedStoresTransfersRoute._addFileChildren(
    AuthenticatedStoresTransfersRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedHelpRoute: typeof AuthenticatedHelpRoute
  AuthenticatedProductionPackconvRoute: typeof AuthenticatedProductionPackconvRouteWithChildren
  AuthenticatedPurchasingIntakeRoute: typeof AuthenticatedPurchasingIntakeRouteWithChildren
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRouteWithChildren
  AuthenticatedSalesInvoicingRoute: typeof AuthenticatedSalesInvoicingRouteWithChildren
  AuthenticatedSearchRoute: typeof AuthenticatedSearchRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedSiloCountsRoute: typeof AuthenticatedSiloCountsRouteWithChildren
  AuthenticatedStoresTransfersRoute: typeof AuthenticatedStoresTransfersRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedProductsProductIdRoute: typeof AuthenticatedProductsProductIdRoute
  AuthenticatedProductsIndexRoute: typeof AuthenticatedProductsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedHelpRoute: AuthenticatedHelpRoute,
  AuthenticatedProductionPackconvRoute:
    AuthenticatedProductionPackconvRouteWithChildren,
  AuthenticatedPurchasingIntakeRoute:
    AuthenticatedPurchasingIntakeRouteWithChildren,
  AuthenticatedReportsRoute: AuthenticatedReportsRouteWithChildren,
  AuthenticatedSalesInvoicingRoute:
    AuthenticatedSalesInvoicingRouteWithChildren,
  AuthenticatedSearchRoute: AuthenticatedSearchRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedSiloCountsRoute: AuthenticatedSiloCountsRouteWithChildren,
  AuthenticatedStoresTransfersRoute:
    AuthenticatedStoresTransfersRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedProductsProductIdRoute: AuthenticatedProductsProductIdRoute,
  AuthenticatedProductsIndexRoute: AuthenticatedProductsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
